<template>
	<div>
		<div class="content-zsy" v-if="!isMobile">
			<el-row>
				<el-col :span="7">
					<div class="navi">
						<div class="widget-sub-navi-mypage">
							<h2>마이페이지</h2>
							  <div class="box">
									<div class="info">
										<div class="level-icon"><i class="el-icon-trophy" style="color: #5a5a5a;" ></i><!-- <img src="../../assets/icon.4" alt="사업자(일반)"> --></div>
										<strong>{{nickname}}</strong>님 환영합니다.  <!-- <a href="/member/setting" class="link-setting"></a> -->
									</div>
									<div class="group">
										<div class="left">
											<div class="level">
												<!-- 사업자(일반) 회원 -->
												{{user_info.level}}
											</div>
											<div class="post">개인 번호 : <span style="color: #e74c3c;">{{user_info.post_id}}</span></div>
										</div>
										<div class="link">
											<router-link to="/documentAddress" style="margin-bottom: 5px;">나의 중국 주소</router-link>
											<router-link to="/addressBook">배송지 설정</router-link>
										</div>
									</div>
									<div class="msg">
										<div>
											읽지 않은 메세지 <strong>{{statistics.unread_message_num}}</strong>건
										</div>
										<router-link to="/message">확인하기</router-link>
									</div>  
							</div>
	
						</div>
						<!-- PC 端专属服务菜单 Desktop Coupang Dedicated Service Menu-->
						<div class="coupang-menu-section" style="margin-bottom: 20px;">
							<div class="coupang-menu-title" style="margin-top: 0;">
								쿠팡 1P/2P 전용 서비스
							</div>
							
							<ul style="list-style: none; padding: 0; margin: 0;">

								<!-- Group 1: 상품등록 관리 -->
								<li class="coupang-group-li group-product">
									<a @click="toggleGroup('product')" class="coupang-group-header">
										<span>상품등록 관리</span>
										<i :class="expandedGroups.product ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="arrow-icon"></i>
									</a>
									<ul v-show="expandedGroups.product" class="coupang-sub-menu">
										<li :class="{ 'active-coupang-item': activeMenu === 'coupang_inventory_write' }">
											<a @click="selectCoupangMenu('coupang_inventory_write')">상품등록</a>
										</li>
										<li :class="{ 'active-coupang-item': activeMenu === 'coupang_item_xls_upload' }">
											<a @click="selectCoupangMenu('coupang_item_xls_upload')">대량등록(Excel)</a>
										</li>
										<li :class="{ 'active-coupang-item': activeMenu === 'coupang_inventory_item' }">
											<a @click="selectCoupangMenu('coupang_inventory_item')">상품등록 현황</a>
										</li>
									</ul>
								</li>

								<!-- Group 2: 입고관리 -->
								<li class="coupang-group-li group-inbound">
									<a @click="toggleGroup('inbound')" class="coupang-group-header">
										<span>입고관리</span>
										<i :class="expandedGroups.inbound ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="arrow-icon"></i>
									</a>
									<ul v-show="expandedGroups.inbound" class="coupang-sub-menu">
										<li :class="{ 'active-coupang-item': activeMenu === 'coupang_warehouse_write' }">
											<a @click="selectCoupangMenu('coupang_warehouse_write')">입고신청</a>
										</li>
										<li :class="{ 'active-coupang-item': activeMenu === 'coupang_warehouse_xls_upload' }">
											<a @click="selectCoupangMenu('coupang_warehouse_xls_upload')">대량입고신청(Excel)</a>
										</li>
										<li :class="{ 'active-coupang-item': activeMenu === 'coupang_inventory_warehouse' }">
											<a @click="selectCoupangMenu('coupang_inventory_warehouse')">입고 신청 현황</a>
										</li>
										<li :class="{ 'active-coupang-item': activeMenu === 'coupang_inventory_warehouse_complete' }">
											<a @click="selectCoupangMenu('coupang_inventory_warehouse_complete')">입고 완료 현황</a>
										</li>
									</ul>
								</li>

								<!-- Group 3: 발송관리 -->
								<li class="coupang-group-li group-outbound">
									<a @click="toggleGroup('outbound')" class="coupang-group-header">
										<span>발송관리</span>
										<i :class="expandedGroups.outbound ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="arrow-icon"></i>
									</a>
									<ul v-show="expandedGroups.outbound" class="coupang-sub-menu">
										<li :class="{ 'active-coupang-item': activeMenu === 'coupang_inventory_packing_write' }">
											<a @click="selectCoupangMenu('coupang_inventory_packing_write')">발송신청</a>
										</li>
										<li :class="{ 'active-coupang-item': activeMenu === 'coupang_packing_xls_upload' }">
											<a @click="selectCoupangMenu('coupang_packing_xls_upload')">발송엑셀등록</a>
										</li>
										<li :class="{ 'active-coupang-item': activeMenu === 'coupang_inventory_packing' }">
											<a @click="selectCoupangMenu('coupang_inventory_packing')">발송현황</a>
										</li>
									</ul>
								</li>
							</ul>
						</div>

						<div class="menu-box" style="border-top: 1px dashed #ddd; padding-top: 20px;">
							<ul>
								<li class="menu-all" :class="{ 'active-coupang-item': activeMenu === 'default' }">
									<a @click="selectCoupangMenu('default')">전체리스트</a>
								</li>
								<li class="menu-review" :class="{ 'active-coupang-item': activeMenu === 'coupang_review_writeble' }">
									<a @click="selectCoupangMenu('coupang_review_writeble')">나의 리뷰</a>
								</li>
								<!-- <li class="menu-pay" :class="{ 'active-coupang-item': activeMenu === 'coupang_agency_invoice_write' }">
									<a @click="selectCoupangMenu('coupang_agency_invoice_write')">대리결제</a>
								</li> -->
								<li class="menu-inventory" :class="{ 'active-coupang-item': activeMenu === 'coupang_inventory_guide' }">
									<a @click="selectCoupangMenu('coupang_inventory_guide')">재고보관</a>
								</li>
								<li class="menu-nodata" :class="{ 'active-coupang-item': activeMenu === 'coupang_nodata' }">
									<a @click="selectCoupangMenu('coupang_nodata')">노데이터</a>
								</li>
								<li class="menu-agency" :class="{ 'active-coupang-item': activeMenu === 'coupang_agency_list' }">
									<a @click="selectCoupangMenu('coupang_agency_list')">대행 신청/결제</a>
								</li>
								<li class="menu-coupang-delivery" :class="{ 'active-coupang-item': activeMenu === 'coupang_inventory_list' }">
									<a @click="selectCoupangMenu('coupang_inventory_list')">쿠팡 발송 신청/결제</a>
								</li>
								<li class="menu-recharge">
									<a @click="onCybercash">머니 충전</a>
								</li>
								<li class="menu-recharge">
									<a @click="onExchange">환전 신청</a>
								</li>
								
							</ul>
						</div>
					  
					  
					  
					</div>
				  
			  </el-col>
			  <el-col :span="17">
				<div v-if="activeMenu === 'default'">
					<div v-show="!viewingDetailsId">
						<div ref="countBoxWrapper" style="min-height: 168px; margin-bottom: 20px;">
						<div class="count-box" :style="countBoxStyle" ref="countBox">
							<div class="unit">
								<div class="title">통합 메시지함</div>
								<div class="content">
									<span class="">{{statistics.message_num}}건</span>
								</div>
								<div class="link">
									<router-link to="/message">내역보기</router-link>
								</div>
							</div>
							<div class="unit">
								<div class="title">나의 문의내역</div>
								<div class="content">
									{{statistics.consult_num}}건
								</div>
								<div class="link">
									<router-link to="/oneConsult">문의하기</router-link>
								</div>
							</div>
							<div class="unit">
								<div class="title">결제내역</div>
								<div class="content">
									{{statistics.payment_num}}건
								</div>
								<div class="link">
									<router-link to="/pay">내역보기</router-link>
								</div>
							</div>
							<!-- <div class="unit">
								<div class="title">나의 쿠폰</div>
								<div class="content">
									{{statistics.coupon_num}}장                    
								</div>
								<div class="link">
									<router-link to="/coupon">내역보기</router-link>
								</div>
							</div> -->
							<div class="unit">
								<div class="title">로켓머니(위안)</div>
								<div class="content">
									{{statistics.money_cny}}元
								</div>
								<div class="link">
									<router-link to="/cyberCashHistory?currency=CNY">내역보기</router-link>
								</div>
							</div>
							<div class="unit">
								<div class="title">로켓머니</div>
								<div class="content">
									{{statistics.money}}원
								</div>
								<div class="link">
									<router-link to="/cyberCashHistory">내역보기</router-link>
								</div>
							</div>
						</div>
						</div>
						
						<div class="need-box">
							<div class="unit">
								<div class="title">필수 확인 사항</div>
								<div class="content">
									<ul>
										<li class="">
											구매 결제대기		<span>{{item_num.buy_num}}건</span>
										</li>
										<li class="">
											배송 결제대기		<span>{{item_num.delivery_num}}건</span>
										</li>
										<li class="">
											확인요청		<span>{{item_num.receipt_num}}건</span>
										</li>
									</ul>
				<!-- 					<form name="form-member-coupon-code-issue" method="post" action="/member/coupon-code-issue-ok" target="actionFrame" autocomplete="off">
										<input name="_token_" type="hidden" value="t5zd9mXkXF03mbdDoe8oWw">
										<input name="targetUrl" type="hidden" value="">
										<div class="box">
											<label>쿠폰번호 입력</label>
											<input name="couponCode" type="text" size="30" class="type-text" value="" placeholder="쿠폰 코드를 입력해 주세요.">
											<button type="button" class="btn btn-submit event-common-click-submit">입력</button>
										</div>
									</form> -->
								</div>
							</div>
						</div>
						
						<div class="widget-agency-mypage-report">
							<h3>주문내역</h3>
							<div class="wrap">
								<div class="unit">
									<h4>구매대행</h4>
									<div class="box">
										<table class="table-mypage-report">
											<tbody>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'HABA', name: '결제대기' } }" @click.native.prevent="onOrderList('HABA','결제대기')" class="view-group" :class="{ active: status === 'HABA' }">
														<div class="view-group-basic">결제대기</div>
														<strong class="view-group-addon">{{orders.status_haba}}</strong>
													</router-link>
												</td>
											</tr>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'HBAA', name: '결제완료' } }" @click.native.prevent="onOrderList('HBAA','결제완료')" class="view-group" :class="{ active: status === 'HBAA' }">
														<div class="view-group-basic">결제완료</div>
														<strong class="view-group-addon">{{orders.status_hbaa}}</strong>
													</router-link>
												</td>
											</tr>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'HDCA', name: '구매완료' } }" @click.native.prevent="onOrderList('HDCA','구매완료')" class="view-group" :class="{ active: status === 'HDCA' }">
														<div class="view-group-basic">구매완료</div>
														<strong class="view-group-addon">{{orders.status_hdca}}</strong>
													</router-link>
												</td>
											</tr>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'HXXA', name: '구매취소' } }" @click.native.prevent="onOrderList('HXXA','구매취소')" class="view-group" :class="{ active: status === 'HXXA' }">
														<div class="view-group-basic">구매취소</div>
														<strong class="view-group-addon">{{orders.status_hxxa}}</strong>
													</router-link>
												</td>
											</tr>
											</tbody>
										</table>
									</div>
								</div>
						
								<div class="unit">
									<h4>배송대행</h4>
									<div class="box">
										<table class="table-mypage-report">
											<tbody>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'AAAA', name: '신청접수' } }" @click.native.prevent="onOrderList('AAAA','신청접수')" class="view-group" :class="{ active: status === 'AAAA' }">
														<div class="view-group-basic">신청접수</div>
														<strong class="view-group-addon" style="color: #0055d4;">{{orders.status_aaaa}}</strong>
													</router-link>
												</td>
											</tr>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'AACA', name: '입고완료' } }" @click.native.prevent="onOrderList('AACA','입고완료')" class="view-group" :class="{ active: status === 'AACA' }">
														<div class="view-group-basic">입고완료</div>
														<strong class="view-group-addon">{{orders.status_aaca}}</strong>
													</router-link>
												</td>
											</tr>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'AADA', name: '배송요청' } }" @click.native.prevent="onOrderList('AADA','배송요청')" class="view-group" :class="{ active: status === 'AADA' }">
														<div class="view-group-basic">배송요청</div>
														<strong class="view-group-addon">{{orders.status_aada}}</strong>
													</router-link>
												</td>
											</tr>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'ABAA', name: '결제대기' } }" @click.native.prevent="onOrderList('ABAA','결제대기')" class="view-group" :class="{ active: status === 'ABAA' }">
														<div class="view-group-basic">결제대기</div>
														<strong class="view-group-addon">{{orders.status_abaa}}</strong>
													</router-link>
												</td>
											</tr>
											</tbody>
										</table>
									</div>
								</div>
						
								<div class="unit">
									<h4>국제배송</h4>
									<div class="box">
										<table class="table-mypage-report">
											<tbody>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'ACAA', name: '결제완료' } }" @click.native.prevent="onOrderList('ACAA','결제완료')" class="view-group" :class="{ active: status === 'ACAA' }">
														<div class="view-group-basic">결제완료</div>
														<strong class="view-group-addon">{{orders.status_acaa}}</strong>
													</router-link>
												</td>
											</tr>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'ACBA', name: '출고보류' } }" @click.native.prevent="onOrderList('ACBA','출고보류')" class="view-group" :class="{ active: status === 'ACBA' }">
														<div class="view-group-basic">출고보류</div>
														<strong class="view-group-addon">{{orders.status_acba}}</strong>
													</router-link>
												</td>
											</tr>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'ADAA', name: '발송완료' } }" @click.native.prevent="onOrderList('ADAA','발송완료')" class="view-group" :class="{ active: status === 'ADAA' }">
														<div class="view-group-basic">발송완료</div>
														<strong class="view-group-addon">{{orders.status_adaa}}</strong>
													</router-link>
												</td>
											</tr>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'ADCA', name: '통관 중' } }" @click.native.prevent="onOrderList('ADCA','통관 중')" class="view-group" :class="{ active: status === 'ADCA' }">
														<div class="view-group-basic">통관 중</div>
														<strong class="view-group-addon">{{orders.status_adca}}</strong>
													</router-link>
												</td>
											</tr>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'ADDA', name: '통관완료' } }" @click.native.prevent="onOrderList('ADDA','통관완료')" class="view-group" :class="{ active: status === 'ADDA' }">
														<div class="view-group-basic">통관완료</div>
														<strong class="view-group-addon">{{orders.status_adda}}</strong>
													</router-link>
												</td>
											</tr>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'AXAA', name: '배송완료' } }" @click.native.prevent="onOrderList('AXAA','배송완료')" class="view-group" :class="{ active: status === 'AXAA' }">
														<div class="view-group-basic">배송완료</div>
														<strong class="view-group-addon">{{orders.status_axaa}}</strong>
													</router-link>
												</td>
											</tr>
											</tbody>
										</table>
									</div>
								</div>
						
								<div class="unit crash">
									<h4>사고</h4>
									<div class="box">
										<table class="table-mypage-report">
											<tbody>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'QA', name: '확인요청' } }" @click.native.prevent="onOrderList('QA','확인요청')" class="view-group" :class="{ active: status === 'QA' }">
														<div class="view-group-basic">확인요청</div>
														<strong class="view-group-addon">{{orders.status_qa}}</strong>
													</router-link>
												</td>
											</tr>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'AACB', name: '일부수량입고' } }" @click.native.prevent="onOrderList('AACB','일부수량입고')" class="view-group" :class="{ active: status === 'AACB' }">
														<div class="view-group-basic">일부수량입고</div>
														<strong class="view-group-addon">{{orders.status_aacb}}</strong>
													</router-link>
												</td>
											</tr>
											<tr>
												<td>
													<router-link :to="{ query: { status: 'QB', name: '미도착 사고건' } }" @click.native.prevent="onOrderList('QB','미도착 사고건')" class="view-group" :class="{ active: status === 'QB' }">
														<div class="view-group-basic">미도착 사고건</div>
														<strong class="view-group-addon">{{orders.status_qb}}</strong>
													</router-link>
												</td>
											</tr>
											<!-- <tr>
												<td>
													<router-link :to="{ query: { status: 'QC', name: '취소/반품/환불' } }" @click.native.prevent="onOrderList('QC','취소/반품/환불')" class="view-group" :class="{ active: status === 'QC' }">
														<div class="view-group-basic">취소/반품/환불</div>
														<strong class="view-group-addon">{{orders.status_qc}}</strong>
													</router-link>
												</td>
											</tr> -->
											<tr>
												<td>
													<router-link :to="{ query: { status: 'XX', name: '폐기처리' } }" @click.native.prevent="onOrderList('XX','폐기처리')" class="view-group" :class="{ active: status === 'XX' }">
														<div class="view-group-basic">폐기처리</div>
														<strong class="view-group-addon">{{orders.status_xx}}</strong>
													</router-link>
												</td>
											</tr>
											</tbody>
										</table>
									</div>
								</div>
						
								<div class="unit">
									<h4>반송</h4>
									<div class="box">
										<table class="table-mypage-report">
											<tbody>
											<tr>
												<td>
													<a @click="onOrderList('TA','반송신청')" class="view-group" :class="{ active: status === 'TA' }">
														<div class="view-group-basic">반송신청</div>
														<span class="view-group-addon">0</span>
													</a>
												</td>
											</tr>
											<tr>
												<td>
													<a @click="onOrderList('TB','결제대기')" class="view-group" :class="{ active: status === 'TB' }">
														<div class="view-group-basic">결제대기</div>
														<span class="view-group-addon">0</span>
													</a>
												</td>
											</tr>
											<tr>
												<td>
													<a @click="onOrderList('TC','결제완료')"  class="view-group" :class="{ active: status === 'TC' }">
														<div class="view-group-basic">결제완료</div>
														<span class="view-group-addon">0</span>
													</a>
												</td>
											</tr>
											<tr>
												<td>
													<a @click="onOrderList('TD','반송완료')" class="view-group" :class="{ active: status === 'TD' }">
														<div class="view-group-basic">반송완료</div>
														<span class="view-group-addon">0</span>
													</a>
												</td>
											</tr>
											<tr>
												<td>
													<a @click="onOrderList('TE','반송불가')" class="view-group" :class="{ active: status === 'TE' }">
														<div class="view-group-basic">반송불가</div>
														<span class="view-group-addon">0</span>
													</a>
												</td>
											</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							
						</div>
					</div>
					
					<!-- 详细信息 (Detail Info View) -->
					<div v-if="viewingDetailsId" style="padding: 20px; background: #fff; border-radius: 8px; box-shadow: 0 1px 6px rgba(0,0,0,0.05); min-height: 400px;">
						<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; border-bottom: 2px solid #ebeef5; padding-bottom: 16px;">
							<h4 style="margin: 0; font-size: 20px; font-weight: bold; color: #303133;">상세 정보 (주문번호: {{info.platform_order_no}})</h4>
							<div style="display: flex; gap: 8px;">
								<!-- <el-button type="primary" plain round size="small" @click="onEdit" v-if="edit_button" icon="el-icon-edit">상품수정</el-button> -->
								<el-button type="primary" size="small" icon="el-icon-back" round @click="closeDetails">목록으로 돌아가기</el-button>
							</div>
						</div>

						<el-descriptions title="기본 정보" direction="vertical" :column="isMobile ? 2 : 4" border style="margin-bottom: 24px;">
						  <el-descriptions-item label="배송센터">
							<div>{{ info.delivery_center_code || '해상' }}</div>
							<div class="label-warehouse" style="margin-top: 4px; font-weight: bold; color: #409eff;">{{ info.status_name }}</div>
						  </el-descriptions-item>
						  <el-descriptions-item label="아이템번호">{{ info.id }}</el-descriptions-item>
						  <el-descriptions-item label="신청서번호">{{ info.apply_num }}</el-descriptions-item>
						  <el-descriptions-item label="등록일">{{ info.createtime }}</el-descriptions-item>

						  <el-descriptions-item label="상품명" :span="2">{{ info.goods_name }}</el-descriptions-item>
						  <el-descriptions-item label="품목분류">{{ info.category }}</el-descriptions-item>
						  <el-descriptions-item label="관리코드">{{ info.refer_code }}</el-descriptions-item>

						  <el-descriptions-item label="색상">{{ info.color }}</el-descriptions-item>
						  <el-descriptions-item label="사이즈">{{ info.size }}</el-descriptions-item>
						  <el-descriptions-item label="재고상품코드">{{ info.code }}</el-descriptions-item>
						  <el-descriptions-item label="단가">{{ info.price }} CNY</el-descriptions-item>

						  <el-descriptions-item label="주문수량">{{ info.apply_quantity }}</el-descriptions-item>
						  <el-descriptions-item label="입고수량">{{ info.stock_qty || '-' }}</el-descriptions-item>
						  <el-descriptions-item label="오더넘버">{{ info.order_no }}</el-descriptions-item>
						  <el-descriptions-item label="트래킹넘버">{{ info.tracking_no }}</el-descriptions-item>

						  <el-descriptions-item label="쉬핑네임">{{ info.ship_name }}</el-descriptions-item>
						  <el-descriptions-item label="창고도착일">-</el-descriptions-item>
						  <el-descriptions-item label="입고완료일">-</el-descriptions-item>
						  <el-descriptions-item label="결제완료일">-</el-descriptions-item>

						  <el-descriptions-item label="발송완료일">-</el-descriptions-item>
						  <el-descriptions-item label="배송완료일">-</el-descriptions-item>
						  <el-descriptions-item label="포장 박스수량">-</el-descriptions-item>
						  <el-descriptions-item label="국내 쇼핑몰">-</el-descriptions-item>

						  <el-descriptions-item label="URL" :span="isMobile ? 2 : 4">
							<a :href="info.url" target="_blank" style="color: #409eff; text-decoration: none; word-break: break-all;">{{ info.url }}</a>
						  </el-descriptions-item>
						  <el-descriptions-item label="입고 요청메세지" :span="isMobile ? 2 : 4">{{ info.shipping_memo }}</el-descriptions-item>
						</el-descriptions>
					</div>

				</div>
				<div v-else class="embed-component-wrapper">
					<InventoryWrite v-if="activeMenu === 'coupang_inventory_write'" />
					<ItemXlsUpload v-else-if="activeMenu === 'coupang_item_xls_upload'" />
					<InventoryItem v-else-if="activeMenu === 'coupang_inventory_item'" />
					<WarehouseWrite v-else-if="activeMenu === 'coupang_warehouse_write'" />
					<WarehouseXlsUpload v-else-if="activeMenu === 'coupang_warehouse_xls_upload'" />
					<InventoryWarehouse v-else-if="activeMenu === 'coupang_inventory_warehouse'" />
					<InventoryWarehouseComplete v-else-if="activeMenu === 'coupang_inventory_warehouse_complete'" />
					<InventoryPackingWrite v-else-if="activeMenu === 'coupang_inventory_packing_write'" />
					<PackingXlsUpload v-else-if="activeMenu === 'coupang_packing_xls_upload'" />
					<InventoryPacking v-else-if="activeMenu === 'coupang_inventory_packing'" />
					<ReviewWriteble v-else-if="activeMenu === 'coupang_review_writeble'" />
					<AgencyInvoiceWrite v-else-if="activeMenu === 'coupang_agency_invoice_write'" />
					<InventoryGuide v-else-if="activeMenu === 'coupang_inventory_guide'" />
					<Nodata v-else-if="activeMenu === 'coupang_nodata'" />
					<AgencyList v-else-if="activeMenu === 'coupang_agency_list'" />
					<InventoryList v-else-if="activeMenu === 'coupang_inventory_list'" />
				</div>
			  </el-col>
			  
			</el-row>
			<div v-if="activeMenu === 'default'" v-show="!viewingDetailsId">
				<div class="event-change-agency-list">
				<ul>
					<li class="type-cn_ship" :class="{ active: deliveryCenterCode === 'CN_SHIP' }">
						<a @click="onChangeDeliveryCenter('CN_SHIP')">해상</a>
					</li>
					<li class="type-cn_lcl" :class="{ active: deliveryCenterCode === 'CN_LCL' }">
						<a @click="onChangeDeliveryCenter('CN_LCL')">LCL화물</a>
					</li>
					<!-- <li class="type-cn_air">
						<a href="">항공</a>
					</li> -->
				</ul>
			</div>
			<div class="search-box">
				<el-form ref="form" :model="searchForm" label-width="80px" size="small">
					<div class="search-box__grid">
						<div class="search-box__field">
							<label class="search-box__label">선택검색</label>
							<div class="search-box__input-group">
								<el-select v-model="searchForm.s" placeholder="선택" class="search-box__select">
									<el-option label="관리코드" value="referCode"></el-option>
									<el-option label="재고상품코드" value="code"></el-option>
									<el-option label="오더넘버" value="platformOrderNo"></el-option>
									<el-option label="오더넘버(1688/taobao)" value="orderNo"></el-option>
									<el-option label="아이템번호" value="itemId"></el-option>
									<el-option label="수취인명" value="realname"></el-option>
									<el-option label="수취인 연락처" value="hp"></el-option>
								</el-select>
								<el-input v-model="searchForm.k" placeholder="검색어를 입력하세요" class="search-box__keyword"></el-input>
							</div>
						</div>
						<div class="search-box__field">
							<label class="search-box__label">출고보류</label>
							<el-select v-model="searchForm.deliveryLock" placeholder="선택하세요" class="search-box__select--full">
								<el-option label="선택하세요" value></el-option>
								<el-option label="출고보류함" value="1"></el-option>
								<el-option label="출고보류안함" value="2"></el-option>
							</el-select>
						</div>
						<div class="search-box__field">
							<label class="search-box__label">신청일자</label>
							<div class="search-box__date-range">
								<el-date-picker type="date" v-model="searchForm.date1" placeholder="시작일" style="flex: 1;"></el-date-picker>
								<span class="search-box__date-sep">~</span>
								<el-date-picker type="date" v-model="searchForm.date2" placeholder="종료일" style="flex: 1;"></el-date-picker>
							</div>
						</div>
						<div class="search-box__actions">
							<el-button class="search-box__btn-search" @click="onSubmit">검색</el-button>
							<el-button class="search-box__btn-reset" @click="onReset">초기화</el-button>
						</div>
					</div>
				</el-form>
			</div>
			<div class="list-top">
				<div class="current-status">{{current_status_name}}</div>
				<div class="page-info">
					<span>전체 : <strong>{{total}}</strong> ( {{current_page}}/{{last_page}} 페이지)</span>
				</div>
			</div>
			<el-table
				:data="tableData" empty-text="데이타가 없습니다."
				style="width: 100%;">
	<!-- 			<el-table-column
				label="메뉴"
				width="80">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" v-if="scope.row.status==1" @click="handleEdit(scope.$index, scope.row)">상세보기</el-button>
					</template>
				</el-table-column> -->
				<!-- <el-table-column
				label="신청서번호"
				width="85">
					<template slot-scope="scope">
						<div>해상</div>
						<div>-</div>
					</template>
				</el-table-column>
				<el-table-column
				prop=""
				label="아이템번호"
				width="120">
				--
				</el-table-column> -->
				<el-table-column
				label="상태"
				width="100">
					<template slot-scope="scope">
						<div style="color:#67C23A;">[{{scope.row.inventory_status}}]</div>
						<div>{{ scope.row.status_name }}</div>
					</template>
				</el-table-column>
				<el-table-column
				label="사진"
				width="80">
					<template slot-scope="scope">
						<!-- 动态显示商品图片 goods_image 字段，如果没有则显示默认无图占位 -->
						<el-popover placement="right" trigger="hover" v-if="scope.row.goods_image">
							<el-image 
								style="max-width: 300px; max-height: 300px;" 
								:src="scope.row.goods_image.startsWith('//') ? 'https:' + scope.row.goods_image : scope.row.goods_image" 
								fit="contain">
								<div slot="error" class="image-slot" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; background: #f5f7fa; color: #909399;">
									<i class="el-icon-picture-outline" style="font-size: 30px;"></i>
								</div>
							</el-image>
							<el-image slot="reference"
								style="width: 50px; height: 50px; border-radius: 4px; border: 1px solid #eee; cursor: pointer;"
								:src="scope.row.goods_image.startsWith('//') ? 'https:' + scope.row.goods_image : scope.row.goods_image"
								fit="cover">
								<div slot="error" class="image-slot" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; background: #f5f7fa; color: #909399; font-size: 11px;">
									<img style="width: 100%; height: 100%;" :src="SERVER_URL + '/assets/img/no_thumb.png'" alt="no image">
								</div>
							</el-image>	
						</el-popover>
						<el-image v-else
							 style="width: 50px; height: 50px; border-radius: 4px; border: 1px solid #eee;"
							 :src="SERVER_URL + '/assets/img/no_thumb.png'"
							 fit="cover">
							 <div slot="error" class="image-slot" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; background: #f5f7fa; color: #909399; font-size: 11px;">
								<img style="width: 100%; height: 100%;" :src="SERVER_URL + '/assets/img/no_thumb.png'" alt="no image">
							 </div>
						</el-image>		
					</template>
				</el-table-column>
				<el-table-column
				prop="name"
				label="상품정보"
				width="200">
					<template slot-scope="scope">
						<div><a style="text-decoration: none;color:#000;" :href="scope.row.url" target="_blank">{{ scope.row.goods_name }}</a></div>
						<div><span style="padding-right: 20px;">¥{{scope.row.price}}</span> <span>{{ scope.row.apply_quantity }} 개</span></div>
						<div v-if="scope.row.color">색상:{{scope.row.color}}</div>
						<div v-if="scope.row.size">사이즈:{{scope.row.size}}</div>
					</template>
				</el-table-column>
				<el-table-column
				prop="platform_order_no"
				label="주문번호"
				width="150">
				</el-table-column>
				<el-table-column
				prop="order_no"
				label=""
				width="150">
					<template slot="header">
						<div>주문번호</div>
						<div>(1688/taobao)</div>
					</template>
				</el-table-column>
				<el-table-column
				prop="tracking_no"
				label="트래킹넘버"
				width="150">
				</el-table-column>
				<el-table-column	
				width="170">
					  <template slot="header">
						<!-- <div>운송장번호</div> -->
						<div>수취인</div>
					  </template>
					  <template slot-scope="scope">
						<!-- <div>{{ scope.row.name }}</div> -->
						<div>{{scope.row.realname}}</div>
					  </template>
				</el-table-column>
				<el-table-column
				label="접수일 출고일"
				width="110">
					<template slot="header">
						<div>접수일</div>
						<div>출고일</div>
					</template>
					<template slot-scope="scope">
						<div>{{ scope.row.createtime_format }}</div>
						<div>{{ scope.row.dispatchtime_format }}</div>
					</template>
				</el-table-column>
	
				<el-table-column label="">
					<template slot-scope="scope">
						<el-button size="mini" style="margin-bottom: 5px;" type="primary"  @click="handleEdit(scope.$index, scope.row)">상세보기</el-button> <!-- v-if="scope.row.status==1" -->
						<!-- <el-button size="mini">1:1 문의</el-button> -->
						<br v-if="scope.row.agency_type != '2'" >
						<el-button
						  v-if="scope.row.agency_type != '2'"
						  size="mini" style="margin-bottom: 5px;"
						  @click="handleTrackingno(scope.$index, scope.row)" >트래킹넘버 입력</el-button>
						<br> 
						<!-- <el-button
							size="mini"
							type="danger" plain  v-if="scope.row.status==1"
							@click="handleDelete(scope.$index, scope.row)">삭제</el-button> -->
						<el-button
							v-if="(scope.row.agency_type == '2' && [30].includes(Number(scope.row.status))) || (scope.row.agency_type != '2' && [1, 6, 7].includes(Number(scope.row.status)))"
							size="mini"
							plain  
							style="color: #ff6a00; border-color: #ff6a00; background-color: #fff5ee;"
							@click="handleModifyAgencyOrder(scope.row)"
							>수정</el-button>
						
					</template>
				</el-table-column>
			</el-table>
			<div class="page">
				<el-pagination
					layout="prev, pager, next" :page-size="20"
					:total="total" @current-change="handleCurrentChange" >
				</el-pagination>
			</div>
			</div>
			
			
			
		</div>
		<div class="content-zsy" v-else>
			<div v-show="!viewingDetailsId">
				<div class="widget-sub-navi-mypage">
				<h2>마이페이지</h2>
				  <div class="box">
						<div class="info">
							<div class="level-icon"><i class="el-icon-trophy" style="color: #5a5a5a;" ></i><!-- <img src="../../assets/icon.4" alt="사업자(일반)"> --></div>
							<strong>{{nickname}}</strong>님 환영합니다.  <!-- <a href="/member/setting" class="link-setting"></a> -->
						</div>
						<div class="group">
							<div class="left">
								<div class="level">
									{{user_info.level}}
								</div>
								<div class="post">개인 번호 : <span style="color: #e74c3c;">{{user_info.post_id}}</span></div>
							</div>
							<div class="link">
								<router-link to="/documentAddress" style="margin-bottom: 5px;">나의 중국 주소</router-link>
								<router-link to="/addressBook">배송지 설정</router-link>
							</div>
						</div>
						<div class="msg">
							<div>
								읽지 않은 메세지 <strong>{{statistics.unread_message_num}}</strong>건
							</div>
							<router-link to="/message">확인하기</router-link>
						</div>  
				</div>
			</div>
			
			<div class="count-box">
				<div class="group">
					<div class="unit">
						<div class="title">통합 메시지함</div>
						<div class="content">
							<span class="">{{statistics.message_num}}건</span>
						</div>
						<div class="link">
							<router-link to="/message">내역보기</router-link>
						</div>
					</div>
					<div class="unit">
						<div class="title">나의 문의내역</div>
						<div class="content">
							{{statistics.consult_num}}건
						</div>
						<div class="link">
							<router-link to="/oneConsult">문의하기</router-link>
						</div>
					</div>	
				</div>
				<div class="group">
					<div class="unit">
						<div class="title">결제내역</div>
						<div class="content">
							{{statistics.payment_num}}건
						</div>
						<div class="link">
							<router-link to="/pay">내역보기</router-link>
						</div>
					</div>
					<div class="unit">
						<div class="title">나의 쿠폰</div>
						<div class="content">
							{{statistics.coupon_num}}장
						</div>
						<div class="link">
							<router-link to="/coupon">내역보기</router-link>
						</div>
					</div>
				</div>
				<div class="unit">
					<div class="title">로켓머니(위안)</div>
					<div class="content">
						{{statistics.money_cny}}元<router-link to="/cyberCashHistory?currency=CNY">내역보기</router-link>
					</div>
				</div>
				<div class="unit" style="margin-top: 10px;">
					<div class="title">로켓머니</div>
					<div class="content">
						{{statistics.money}}원<router-link to="/cyberCashHistory">내역보기</router-link>
					</div>
				</div>
			</div>
			
			<div class="need-box">
				<div class="unit">
					<div class="title">필수 확인 사항</div>
					<div class="content">
						<ul>
							<li class="">
								구매 결제대기		<span>{{item_num.buy_num}}건</span>
							</li>
							<li class="">
								배송 결제대기		<span>{{item_num.delivery_num}}건</span>
							</li>
							<li class="">
								확인요청		<span>{{item_num.receipt_num}}건</span>
							</li>
						</ul>
	<!-- 					<form name="form-member-coupon-code-issue" method="post" action="/member/coupon-code-issue-ok" target="actionFrame" autocomplete="off">
							<input name="_token_" type="hidden" value="KCvKJzb9iYerV1SA7nhMpg">
							<input name="targetUrl" type="hidden" value="">
							<label>쿠폰번호 입력</label>
							<div class="input-wrap">
								<input name="couponCode" type="text" size="30" class="type-text" value="" placeholder="쿠폰 코드를 입력해 주세요.">
								<button type="button" class="btn btn-submit event-common-click-submit">입력</button>
							</div>
						</form> -->
					</div>
				</div>
			</div>
			
			<!-- Mobile Coupang Dedicated Service Menu -->
			<div class="coupang-menu-section" style="margin-bottom: 20px;">
				<div class="coupang-menu-title" style="margin-top: 20px;">
					쿠팡 1P/2P 전용 서비스
				</div>
				
				<ul style="list-style: none; padding: 0; margin: 0;">
					<!-- Group 1: 상품등록 관리 -->
					<li class="coupang-group-li group-product">
						<a @click="toggleGroup('product')" class="coupang-group-header">
							<span>상품등록 관리</span>
							<i :class="expandedGroups.product ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="arrow-icon"></i>
						</a>
						<ul v-show="expandedGroups.product" class="coupang-sub-menu">
							<li>
								<router-link to="/inventoryWrite">상품등록</router-link>
							</li>
							<li>
								<router-link to="/itemXlsUpload">대량등록(Excel)</router-link>
							</li>
							<li>
								<router-link to="/inventoryItem">상품등록 현황</router-link>
							</li>
						</ul>
					</li>

					<!-- Group 2: 입고관리 -->
					<li class="coupang-group-li group-inbound">
						<a @click="toggleGroup('inbound')" class="coupang-group-header">
							<span>입고관리</span>
							<i :class="expandedGroups.inbound ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="arrow-icon"></i>
						</a>
						<ul v-show="expandedGroups.inbound" class="coupang-sub-menu">
							<li>
								<router-link to="/warehouseWrite">입고신청</router-link>
							</li>
							<li>
								<router-link to="/warehouseXlsUpload">대량입고신청(Excel)</router-link>
							</li>
							<li>
								<router-link to="/inventoryWarehouse">입고 신청 현황</router-link>
							</li>
							<li>
								<router-link to="/inventoryWarehouseComplete">입고 완료 현황</router-link>
							</li>
						</ul>
					</li>

					<!-- Group 3: 발송관리 -->
					<li class="coupang-group-li group-outbound">
						<a @click="toggleGroup('outbound')" class="coupang-group-header">
							<span>발송관리</span>
							<i :class="expandedGroups.outbound ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="arrow-icon"></i>
						</a>
						<ul v-show="expandedGroups.outbound" class="coupang-sub-menu">
							<li>
								<router-link to="/inventoryPackingWrite">발송신청</router-link>
							</li>
							<li>
								<router-link to="/packingXlsUpload">발송엑셀등록</router-link>
							</li>
							<li>
								<router-link to="/inventoryPacking">발송현황</router-link>
							</li>
						</ul>
					</li>
				</ul>
			</div>
			
			<div class="menu-box" style="border-top: 1px dashed #ddd; padding-top: 20px;">
				<ul>
					<li class="menu-all"><router-link to="/orderBundle">전체리스트</router-link></li>
					<li class="menu-review"><router-link to="/reviewWriteble">나의 리뷰</router-link></li>
					<!-- <li class="menu-pay"><router-link to="/agencyInvoiceWrite">대리결제</router-link></li> -->
					<li class="menu-inventory"><router-link to="/inventoryGuide">재고보관</router-link></li>
					<li class="menu-nodata"><router-link to="/nodata">노데이터</router-link></li>
					<li class="menu-agency"><router-link to="/agencyList">대행 신청/결제</router-link></li>
					<li class="menu-coupang-delivery"><router-link to="/inventoryList">쿠팡 발송 신청/결제</router-link></li>
					<li class="menu-recharge"><a href="" @click.prevent="onCybercash">머니 충전</a></li>
					<li class="menu-recharge"><a href="" @click.prevent="onExchange">환전 신청</a></li>
				</ul>
			</div>
			<div class="widget-agency-mypage-report">
				<h3>주문내역</h3>
				<div class="wrap">
					<div class="unit">
						<h4>구매대행</h4>
						<ul class="ul list-mypage-report">
							<li>
								<a @click="onOrderList('HABA','결제대기')" class="view-group" :class="{ active: status === 'HABA' }">
									<div class="view-group-basic">결제대기</div>
									<strong class="view-group-addon">{{orders.status_haba}}</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('HBAA','결제완료')" class="view-group" :class="{ active: status === 'HBAA' }">
									<div class="view-group-basic">결제완료</div>
									<strong class="view-group-addon">{{orders.status_hbaa}}</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('HDCA','구매완료')" class="view-group" :class="{ active: status === 'HDCA' }">
									<div class="view-group-basic">구매완료</div>
									<strong class="view-group-addon">{{orders.status_hdca}}</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('HXXA','구매취소')" class="view-group" :class="{ active: status === 'HXXA' }">
									<div class="view-group-basic">구매취소</div>
									<strong class="view-group-addon">{{orders.status_hxxa}}</strong>
								</a>
							</li>
						</ul>
					</div>
					<div class="unit">
						<h4>배송신청</h4>
						<ul class="ul list-mypage-report">
							<li>
								<a @click="onOrderList('AAAA','신청접수')" class="view-group" :class="{ active: status === 'AAAA' }">
									<div class="view-group-basic">신청접수</div>
									<strong class="view-group-addon" style="color: #0055d4;">{{orders.status_aaaa}}</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('AACA','입고완료')" class="view-group" :class="{ active: status === 'AACA' }">
									<div class="view-group-basic">입고완료</div>
									<strong class="view-group-addon">{{orders.status_aaca}}</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('AADA','배송요청')" class="view-group" :class="{ active: status === 'AADA' }">
									<div class="view-group-basic">배송요청</div>
									<strong class="view-group-addon">{{orders.status_aada}}</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('ABAA','결제대기')" class="view-group" :class="{ active: status === 'ABAA' }">
									<div class="view-group-basic">결제대기</div>
									<strong class="view-group-addon">{{orders.status_abaa}}</strong>
								</a>
							</li>
						</ul>
					</div>
					<div class="unit">
						<h4>국제배송</h4>
						<ul class="ul list-mypage-report">
							<li>
								<a @click="onOrderList('ACAA','결제완료')" class="view-group" :class="{ active: status === 'ACAA' }">
									<div class="view-group-basic">결제완료</div>
									<strong class="view-group-addon">{{orders.status_acaa}}</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('ACBA','출고보류')" class="view-group" :class="{ active: status === 'ACBA' }">
									<div class="view-group-basic">출고보류</div>
									<strong class="view-group-addon">{{orders.status_acba}}</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('ADAA','발송완료')" class="view-group" :class="{ active: status === 'ADAA' }">
									<div class="view-group-basic">발송완료</div>
									<strong class="view-group-addon">{{orders.status_adaa}}</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('ADCA','통관중')" class="view-group" :class="{ active: status === 'ADCA' }">
									<div class="view-group-basic">통관중</div>
									<strong class="view-group-addon">{{orders.status_adca}}</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('ADDA','통관완료')" class="view-group" :class="{ active: status === 'ADDA' }">
									<div class="view-group-basic">통관완료</div>
									<strong class="view-group-addon">{{orders.status_adda}}</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('AXAA','배송완료')" class="view-group" :class="{ active: status === 'AXAA' }">
									<div class="view-group-basic">배송완료</div>
									<strong class="view-group-addon">{{orders.status_axaa}}</strong>
								</a>
							</li>
						</ul>
					</div>
					<div class="unit">
						<h4>반송</h4>
						<ul class="ul list-mypage-report">
							<li>
								<a @click="onOrderList('TA','반송요청')" class="view-group">
									<div class="view-group-basic">반송요청</div>
									<strong class="view-group-addon">0</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('TB','결제대기')" class="view-group">
									<div class="view-group-basic">결제대기</div>
									<strong class="view-group-addon">0</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('TC','결제완료')" class="view-group">
									<div class="view-group-basic">결제완료</div>
									<strong class="view-group-addon">0</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('TD','반송완료')" class="view-group">
									<div class="view-group-basic">반송완료</div>
									<strong class="view-group-addon">0</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('TE','반송불가')" class="view-group">
									<div class="view-group-basic">반송불가</div>
									<strong class="view-group-addon">0</strong>
								</a>
							</li>
						</ul>
					</div>
					<div class="unit crash">
						<h4>사고</h4>
						<ul class="ul list-mypage-report">
							<li>
								<a @click="onOrderList('QA','확인요청')" class="view-group">
									<div class="view-group-basic">확인요청</div>
									<strong class="view-group-addon">{{orders.status_qa}}</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('AACB','일부수량입고')" class="view-group">
									<div class="view-group-basic">일부수량입고</div>
									<strong class="view-group-addon">{{orders.status_aacb}}</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('QB','미도착 사고건')" class="view-group">
									<div class="view-group-basic">미도착 사고건</div>
									<strong class="view-group-addon">{{orders.status_qb}}</strong>
								</a>
							</li>
							<li>
								<a @click="onOrderList('XX','폐기처리')" class="view-group">
									<div class="view-group-basic">폐기처리</div>
									<strong class="view-group-addon">{{orders.status_xx}}</strong>
								</a>
							</li>
						</ul>
					</div>
					
					
					
				</div>
			</div>
			
			<div class="search-box">
				<el-form ref="form" :model="searchForm" label-width="90px" size="mini">
					<el-form-item label="선택검색" >
						<el-row>
							<el-col :span="12">
								<el-select v-model="searchForm.s" placeholder="">
									<el-option label="관리코드" value="referCode"></el-option>
									<el-option label="재고상품코드" value="code"></el-option>
									<el-option label="오더넘버" value="platformOrderNo"></el-option>
									<el-option label="오더넘버(1688/taobao)" value="orderNo"></el-option>
									<!-- <el-option label="트래킹넘버" value="trackingNo"></el-option>
									<el-option label="신청서번호" value="orderId"></el-option> -->
									<el-option label="아이템번호" value="itemId"></el-option>
									<!-- <el-option label="송장번호" value="deliveryNumber"></el-option> -->
									<el-option label="수취인명" value="realname"></el-option>
									<el-option label="수취인 연락처" value="hp"></el-option>
								</el-select>
							</el-col>
							<el-col :span="12">
								<el-input v-model="searchForm.k"></el-input>
							</el-col>
						</el-row>
					</el-form-item>
					<!-- <el-form-item label="주문서 타입" >
						<el-select v-model="searchForm.orderType" >
							<el-option label="선택하세요" value></el-option>
							<el-option label="배송대행" value="shipping"></el-option>
							<el-option label="구매대행" value="shopping"></el-option>
							<el-option label="재고입고" value="warehouse"></el-option>
							<el-option label="재고발송" value="packing"></el-option>
						</el-select>
					</el-form-item> -->
				<!-- 	<el-form-item label="유효여부" >
						<el-select v-model="searchForm.customsInfoValid" placeholder="" >
							<el-option label="통관고유부호" value ></el-option>
							<el-option label="미확인" value="N"></el-option>
							<el-option label="유효함" value="success"></el-option>
							<el-option label="유효하지않음" value="fail"></el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="출고보류">
						<el-select v-model="searchForm.deliveryLock" placeholder="" >
							<el-option label="선택하세요" value ></el-option>
							<el-option label="출고보류함" value="1"></el-option>
							<el-option label="출고보류안함" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="신청일자">
						<el-col :span="11">
							<el-date-picker type="date"  v-model="searchForm.date1" style="width: 100%;"></el-date-picker>
						</el-col>
						<el-col :span="2">~</el-col>
						<el-col :span="11">
							<el-date-picker type="date"  v-model="searchForm.date2" style="width: 100%;"></el-date-picker>
						</el-col>
					</el-form-item>
					<el-form-item size="large">
						<el-button type="primary" @click="onSubmit">검색</el-button>
						<el-button @click="onReset">검색 초기화</el-button>
					</el-form-item>
					
				</el-form>
				
			</div>
			
			<div class="event-change-agency-list">
				<ul>
					<li class="type-cn_ship" :class="{ active: deliveryCenterCode === 'CN_SHIP' }">
						<a @click="onChangeDeliveryCenter('CN_SHIP')">해상</a>
					</li>
					<li class="type-cn_lcl" :class="{ active: deliveryCenterCode === 'CN_LCL' }">
						<a @click="onChangeDeliveryCenter('CN_LCL')">LCL화물</a>
					</li>

					<!-- <li class="type-cn_air">
						<a href="/agency/order/status/ACAA/deliveryCenterCode/CN_AIR">항공</a>
					</li> -->
				</ul>
			</div>
			
			<div class="list-top">
				<div class="current-status">{{current_status_name}}</div>
				<div class="page-info">
					<span>전체 : <strong>{{total}}</strong> ( {{current_page}}/{{last_page}} 페이지)</span>
				</div>
			</div>
			
			<div class="order-item-list">
				<div class="group" v-for="(item,index) in tableData" :key="index" >
					<div class="link-wrap" >
						<a  class="btn btn-sm type-blue event-common-click-popup" @click="handleEdit(index, item)" >상세보기</a>
						<!-- <button type="button" class="btn btn-sm " title="" data-toggle="tooltip"><span>메모(0)</span></button> -->
						<!-- <a href="" class="btn btn-sm" target="_blank">1:1문의</a> -->
						<a  class="btn btn-sm" v-if="item.status==1" @click="handleDelete(index, item)" >삭제</a>
						<a  class="btn btn-sm" style="color: #ff6a00; border-color: #ff6a00; margin-left: 5px;"
							v-if="(item.agency_type == '2' && [30, 31, 32, 6, 7].includes(Number(item.status))) || (item.agency_type != '2' && [1, 6, 7].includes(Number(item.status)))"
							@click="handleModifyAgencyOrder(item)" >수정</a>

					</div>
					<div class="order-info-wrap">
						<div class="thumb-box">
							<!-- <div class="thumb no-thumb"></div> -->
							 <el-image
							 style="width: 92px; height: 92px; border-radius: 4px; border: 1px solid #eee;"
							 :src="item.goods_image ? (item.goods_image.startsWith('//') ? 'https:' + item.goods_image : item.goods_image) : SERVER_URL + '/assets/img/no_thumb.png'"
							 fit="cover">
							 <div slot="error" class="image-slot" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; background: #f5f7fa; color: #909399; font-size: 11px;">
								<img style="width: 100%; height: 100%;" :src="SERVER_URL + '/assets/img/no_thumb.png'" alt="no image">
							 </div>
						</el-image>	
						</div>
						<div class="info">
							<div class="unit type">
								<span class="label label-type label-warehouse">[{{item.inventory_status}}]</span> -
								<span class="status">{{item.status_name }}</span>	
							</div>
							<div class="unit goodsname">
								<a referrerpolicy="no-referrer" :href="item.url" target="_blank">
									{{ item.goods_name }}
								</a>
							</div>
							<div class="unit">신청서번호 : <strong>-</strong></div>
							<div class="unit">아이템번호 : -</div>
							<div class="unit option">
								<span>¥{{item.price}}</span> / <span>{{item.apply_quantity}}개</span> / <span v-if="item.color">색상: {{item.color}}</span> / <span v-if="item.size">사이즈: {{item.size}}</span>
							</div>
							<div class="unit">
								주문번호(1688/taobao) : {{item.order_no}} / 트래킹넘버 : {{item.tracking_no}}
							</div>
						</div>
					</div>
					<div class="order-wrap">
						<div class="tracking-box">
							<div class="number type-">
								<!-- <strong>운송장번호</strong>
								<span></span> -->
								<div class="date">
									<ul>
										<li>
											<strong>접수</strong>
											<span>{{item.createtime_format?item.createtime_format:"-"}}</span>
										</li>
										<li>
											<strong>출고</strong>
											<span>{{ item.dispatchtime?item.dispatchtime:"-"}}</span>
										</li>
									</ul>
								</div>
							</div>
							<div class="link"></div>
						</div>
						<div class="center-box">
							<ul>
								<li>
									<strong>배송센터 : </strong>
									<span>해상</span>
								</li>
								<li>
									<strong>수취인 : </strong>
									<span>{{item.realname?item.realname:"-"}}</span>
								</li>
							</ul>
						</div>
					</div>
					<div class="submit-wrap">
						<a href="" v-if="item.agency_type != '2'" @click.prevent="handleTrackingno(index, item)" class="btn btn-sm event-click-tracking-number" title="트래킹넘버 입력" data-id="layer-tracking-number-modify">트래킹넘버 입력</a>
					</div>
						
				</div>
				<div class="page">
					<el-pagination
						layout="prev, pager, next" :page-size="20"
						:total="total" @current-change="handleCurrentChange" >
					</el-pagination>
				</div>
				
			</div>
			</div>
			
			<!-- Mobile 상세 정보 뷰  Mobile详细信息视图 (Mobile Detail Info View) -->
			<div v-if="viewingDetailsId" style="padding: 12px; background: #fff; border-radius: 8px; box-shadow: 0 1px 6px rgba(0,0,0,0.05); min-height: 400px; margin-top: 10px;">
				<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; border-bottom: 2px solid #ebeef5; padding-bottom: 12px;">
					<h4 style="margin: 0; font-size: 16px; font-weight: bold; color: #303133;">상세 정보 (아이템번호: {{info.id}})</h4>
					<div style="display: flex; gap: 6px;">
						<!-- <el-button type="primary" plain round size="mini" @click="onEdit" v-if="edit_button" icon="el-icon-edit">수정</el-button> -->
						<el-button type="primary" size="mini" icon="el-icon-back" round @click="closeDetails">돌아가기</el-button>
					</div>
				</div>

				<el-descriptions title="기본 정보" direction="vertical" :column="2" border style="margin-bottom: 20px;">
				  <el-descriptions-item label="배송센터">
					<div>{{ info.delivery_center_code || '해상' }}</div>
					<div class="label-warehouse" style="margin-top: 4px; font-weight: bold; color: #409eff;">{{ info.status_name }}</div>
				  </el-descriptions-item>
				  <el-descriptions-item label="아이템번호">{{ info.id }}</el-descriptions-item>
				  <el-descriptions-item label="신청서번호">{{ info.apply_num }}</el-descriptions-item>
				  <el-descriptions-item label="등록일">{{ info.createtime }}</el-descriptions-item>

				  <el-descriptions-item label="상품명" :span="2">{{ info.goods_name }}</el-descriptions-item>
				  <el-descriptions-item label="품목분류">{{ info.category }}</el-descriptions-item>
				  <el-descriptions-item label="관리코드">{{ info.refer_code }}</el-descriptions-item>

				  <el-descriptions-item label="색상">{{ info.color }}</el-descriptions-item>
				  <el-descriptions-item label="사이즈">{{ info.size }}</el-descriptions-item>
				  <el-descriptions-item label="재고상품코드">{{ info.code }}</el-descriptions-item>
				  <el-descriptions-item label="단가">{{ info.price }} CNY</el-descriptions-item>

				  <el-descriptions-item label="주문수량">{{ info.apply_quantity }}</el-descriptions-item>
				  <el-descriptions-item label="입고수량">{{ info.stock_qty || '-' }}</el-descriptions-item>
				  <el-descriptions-item label="오더넘버">{{ info.order_no }}</el-descriptions-item>
				  <el-descriptions-item label="트래킹넘버">{{ info.tracking_no }}</el-descriptions-item>

				  <el-descriptions-item label="쉬핑네임">{{ info.ship_name }}</el-descriptions-item>
				  <el-descriptions-item label="창고도착일">-</el-descriptions-item>
				  <el-descriptions-item label="입고완료일">-</el-descriptions-item>
				  <el-descriptions-item label="결제완료일">-</el-descriptions-item>

				  <el-descriptions-item label="발송완료일">-</el-descriptions-item>
				  <el-descriptions-item label="배송완료일">-</el-descriptions-item>
				  <el-descriptions-item label="포장 박스수량">-</el-descriptions-item>
				  <el-descriptions-item label="국내 쇼핑몰">-</el-descriptions-item>

				  <el-descriptions-item label="URL" :span="2">
					<a :href="info.url" target="_blank" style="color: #409eff; text-decoration: none; word-break: break-all;">링크 보기</a>
				  </el-descriptions-item>
				  <el-descriptions-item label="입고 요청메세지" :span="2">{{ info.shipping_memo }}</el-descriptions-item>
				</el-descriptions>
			</div>
		</div>
		
		<el-dialog title="상세정보" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="closeDetailDialog" :close-on-press-escape="false" :width="isMobile?'98%':'1100px'">
			<!-- <div style="display: flex;justify-content:flex-end;margin-bottom: 20px;">
				<el-button type="primary" plain round size="mini" @click="onEdit" v-if="edit_button" >상품수정</el-button>
			</div> -->
			<el-row>
				<el-col :xs="5" :sm="2" class="table-title" >배송센터</el-col>
				<el-col :xs="7" :sm="4" class="table-content">
					<div style="display: flex;flex-direction: column;">
						<div>{{ info.delivery_center_code }}</div>
						<div class="label-warehouse">{{ info.status_name }}	</div>
					</div>
				</el-col>
				<el-col :xs="5" :sm="2" class="table-title">아이템번호</el-col>
				<el-col :xs="7" :sm="4" class="table-content">{{ info.id }}
					<!-- <br>(신청접수) -->
				</el-col>			
				<el-col :xs="5" :sm="2" class="table-title" >신청서번호</el-col>
				<el-col :xs="7" :sm="4" class="table-content" >{{ info.apply_num }}</el-col>
				<el-col :xs="5" :sm="2" class="table-title">등록일</el-col>
				<el-col :xs="7" :sm="4" class="table-content">{{info.createtime}}</el-col>
				
				<el-col :xs="5" :sm="2" class="table-title" >상품명</el-col>
				<el-col :xs="7" :sm="4" class="table-content" >{{info.goods_name}}</el-col>
				<el-col :xs="5" :sm="2" class="table-title">품목분류</el-col>
				<el-col :xs="7" :sm="4" class="table-content">{{info.category}}</el-col>			
				<el-col :xs="5" :sm="2" class="table-title" >관리코드</el-col>
				<el-col :xs="7" :sm="4" class="table-content" >{{info.refer_code}}</el-col>
				<el-col :xs="5" :sm="2" class="table-title">창고도착일</el-col>
				<el-col :xs="7" :sm="4" class="table-content">-</el-col>
				
				<el-col :xs="5" :sm="2" class="table-title" >색상</el-col>
				<el-col :xs="7" :sm="4" class="table-content" >{{info.color}}</el-col>
				<el-col :xs="5" :sm="2" class="table-title">사이즈</el-col>
				<el-col :xs="7" :sm="4" class="table-content">{{info.size}}</el-col>			
				<el-col :xs="5" :sm="2" class="table-title" >재고상품코드</el-col>
				<el-col :xs="7" :sm="4" class="table-content" >{{info.code}}</el-col>
				<el-col :xs="5" :sm="2" class="table-title">입고완료일</el-col>
				<el-col :xs="7" :sm="4" class="table-content">-</el-col>
				
				<el-col :xs="5" :sm="2" class="table-title" >단가</el-col>
				<el-col :xs="7" :sm="4" class="table-content" >{{info.price}} CNY</el-col>
				<el-col :xs="5" :sm="2" class="table-title">주문수량</el-col>
				<el-col :xs="7" :sm="4" class="table-content">{{info.apply_quantity}}</el-col>			
				<el-col :xs="5" :sm="2" class="table-title" >입고수량</el-col>
				<el-col :xs="7" :sm="4" class="table-content" >-</el-col>
				<el-col :xs="5" :sm="2" class="table-title">결제완료일</el-col>
				<el-col :xs="7" :sm="4" class="table-content">-</el-col>
				
				<el-col :xs="5" :sm="2" class="table-title" >오더넘버</el-col>
				<el-col :xs="7" :sm="4" class="table-content" >{{info.order_no}}</el-col>
				<el-col :xs="5" :sm="2" class="table-title">트래킹넘버</el-col>
				<el-col :xs="7" :sm="4" class="table-content">{{info.tracking_no}}</el-col>			
				<el-col :xs="5" :sm="2" class="table-title" >쉬핑네임</el-col>
				<el-col :xs="7" :sm="4" class="table-content" >{{info.ship_name}}</el-col>
				<el-col :xs="5" :sm="2" class="table-title">발송완료일</el-col>
				<el-col :xs="7" :sm="4" class="table-content">-</el-col>
				
				<el-col :xs="5" :sm="2" class="table-title" >상품 관리번호</el-col>
				<el-col :xs="7" :sm="4" class="table-content">-</el-col>
				<el-col :xs="5" :sm="2" class="table-title">포장 박스수량</el-col>
				<el-col :xs="7" :sm="4" class="table-content">-</el-col>			
				<el-col :xs="5" :sm="2" class="table-title" >국내 쇼핑몰</el-col>
				<el-col :xs="7" :sm="4" class="table-content" >-</el-col>
				<el-col :xs="5" :sm="2" class="table-title">배송완료일</el-col>
				<el-col :xs="7" :sm="4" class="table-content">-</el-col>
				
				<el-col :xs="5" :sm="2" class="table-title" >URL</el-col>
				<el-col :xs="19" :sm="10" class="table-content">
					<a :href="info.url" target="_blank">{{info.url}}</a>
				</el-col>
				<el-col :xs="5" :sm="2" class="table-title">입고 요청메세지</el-col>
				<el-col :xs="19" :sm="10" class="table-content">{{info.shipping_memo}}</el-col>			
	
			</el-row>
		</el-dialog>
		
		<el-dialog title="수정하기" :visible.sync="editVisible" :close-on-click-modal="false" :close-on-press-escape="false" :width="isMobile?'96%':'800px'">
			<el-form :model="form"  ref="ruleForm" label-width="0" >
				
				<div class="form-item" >
					<el-row>
						<el-col :xs="24" :sm="12"  class="item"><!--商品名称-->
							<div class="from-title">상품명(영문) <span class="required-addon">(*)</span>
							<el-popover
							   placement="top-start"
							   width="300"
							   trigger="hover"
							   >
							   <div>검색(HS코드네비게이션)에서 보다 정확한 결과를 얻을수 있습니다</div>
									<i class="el-icon-question icon-question" slot="reference"></i>
							</el-popover>
							</div>
							<el-form-item  prop="goods_name"
							:rules="[
								{ required: true, message: '상품명 필수', trigger: 'blur' },
							]">
								<el-input v-model="form.goods_name" class="input-frame" ></el-input>			
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12"  class="item">
							<div class="from-title">상품코드 <span class="required-addon">(*)</span>
							<el-popover
							   placement="top-start"
							   width="300"
							   trigger="hover"
							   >
							    <div>국내마켓 상품관리에 필요한 상품코드를 입력 관리해보세요</div>
								<i class="el-icon-question icon-question" slot="reference"></i>
							 </el-popover>
							</div><!--商品代码-->
							<el-form-item  prop="code" :rules="[
								{ required: true, message: '상품코드 필수', trigger: 'blur' },
							]">
								<el-input v-model="form.code" readonly class="input-frame" ></el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12"  class="item">
							<div class="from-title">관리코드 
							<el-popover
							   placement="top-start"
							   width="300"
							   trigger="hover"
							   >
							    <div>관리코드를 부여해서 관리해보세요</div>
								<i class="el-icon-question icon-question" slot="reference"></i>
							 </el-popover>
							</div><!-- 管理代码 -->
							<el-form-item  prop="refer_code">
								<el-input v-model="form.refer_code" class="input-frame" ></el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12"  class="item">
							<div class="from-title">주문번호(1688/taobao) <span class="required-addon">(*)</span>
							<el-popover
							   placement="top-start"
							   width="300"
							   trigger="hover"
							   >
							    <div>구매 주문번호를 입력해주세요</div>
								<i class="el-icon-question icon-question" slot="reference"></i>
							 </el-popover>
							</div><!-- 订单号 -->
							<el-form-item  prop="order_no" :rules="[
								{ required: true, message: '주문번호 필수', trigger: 'blur' },
							]">
								<el-input v-model="form.order_no" class="input-frame" ></el-input>
							</el-form-item>
						</el-col>
						<!-- 快递单号 -->
						<!-- <el-col :xs="24" :sm="12"  class="item">
							<div class="from-title">트래킹넘버 <span class="required-addon">(*)</span>
							<el-popover
							   placement="top-start"
							   width="300"
							   trigger="hover"
							   >
							    <div>판매자 상품발송후 제공된 트래킹번호를 즉시 입력해주세요<br>입력이 안될경우 노데이터로 분류되어서 입고가 지연됩니다</div>
								<i class="el-icon-question icon-question" slot="reference"></i>
							 </el-popover>
							</div>
							<el-form-item  prop="tracking_no" :rules="[
								{ required: true, message: '트래킹넘버 필수', trigger: 'blur' },
							]">
								<el-input v-model="form.tracking_no" class="input-frame" readonly placeholder="여러개 입력시 ,(콤마)"></el-input>
							</el-form-item>
						</el-col> -->
						<el-col :xs="24" :sm="12"  class="item">
							<div class="from-title">수량 <span class="required-addon">(*)</span></div><!-- 数量 -->
							<el-form-item  prop="apply_quantity"
							:rules="[
								{ required: true, message: '수량 필수', trigger: 'blur' },
							]">
							<div style="display: flex;">
								<el-input v-model="form.apply_quantity" type="number" class="input-frame"  ></el-input>
								<div>개</div>
							</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12"  class="item">
							<div class="from-title">요청메세지 </div><!-- 发货备注 -->
							<el-form-item  prop="shipping_memo">
								<el-input v-model="form.shipping_memo" placeholder="30자 이내로 적어주세요."  class="input-frame"  ></el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12"  class="item">
							<div class="from-title">쉬핑네임 </div><!-- 购物昵称 -->
							<el-form-item  prop="ship_name" >
								<el-input v-model="form.ship_name"  class="input-frame" ></el-input>
							</el-form-item>
						</el-col>
			
					</el-row>
				</div>	
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm('ruleForm')">수정하기</el-button>
			</div>
		</el-dialog>
		
		<el-dialog title="트래킹넘버 입력" :visible.sync="trackingnoVisible" :close-on-click-modal="false" :close-on-press-escape="false" :width="isMobile?'90%':'400px'">
			<div style="margin-bottom: 10px;">
				현재 트래킹넘버:{{info.tracking_no}}
			</div>
			<el-form :model="form">
				<el-form-item label="" >
					<el-input v-model="tracking_no" autocomplete="off"></el-input>
				</el-form-item>
			
			</el-form>
		  <div slot="footer" >
		    <el-button type="primary"  @click="submitTrackingno">저장하기</el-button>
		  </div>
		</el-dialog>
		
		<el-dialog title="로켓머니 충전 신청" :visible.sync="rechargeVisible" :close-on-click-modal="false" :close-on-press-escape="false" :width="isMobile?'90%':'500px'">
			<div style="margin-bottom: 20px; text-align: center;">
				<el-radio-group v-model="rechargeForm.currency">
					<el-radio label="KRW">원화(KRW)</el-radio>
					<el-radio label="CNY">위안화(CNY/人民币)</el-radio>
				</el-radio-group>
			</div>
			<div class="bank-info" style="background:#f5f8fd; padding:15px; border-radius:10px; margin-bottom:20px;">
				<h4 style="margin-top:0; color:#0055d4;">무통장 입금 계좌</h4>
				<div v-if="rechargeForm.currency === 'KRW'" style="font-size:14px; line-height:1.8;">
					<strong>은행명:</strong> 국민은행<br>
					<strong>계좌번호:</strong> 1234-5678-9012<br>
					<strong>예금주:</strong> (주)고로켓고
				</div>
				<div v-if="rechargeForm.currency === 'CNY'" style="font-size:14px; line-height:1.8;">
					<strong>은행명(银行):</strong> 中国银行 (중국은행)<br>
					<strong>계좌번호(账号):</strong> 1234-5678-9012<br>
					<strong>예금주(开户名):</strong> (주)고로켓고
				</div>
			</div>
			<el-form :model="rechargeForm" label-width="120px">
				<el-form-item :label="rechargeForm.currency === 'KRW' ? '충전금액(원)' : '충전금액(위안)'" required>
					<el-input v-model="rechargeForm.amount" type="number" placeholder="입금하신 금액을 입력하세요"></el-input>
				</el-form-item>
				<el-form-item label="입금자 성명" required>
					<el-input v-model="rechargeForm.remitter_name" placeholder="실제 입금자명을 입력하세요"></el-input>
				</el-form-item>
				<el-form-item label="입금일자" required>
					<el-date-picker v-model="rechargeForm.remittance_date" type="date" placeholder="입금일자 선택" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
				</el-form-item>
					<el-form-item label="회원번호" required>
					<el-input v-model="rechargeForm.post_id" placeholder="회원 고유번호를 입력하세요"></el-input>
				</el-form-item>
				<el-form-item label="입금증명서" required>
			  		<el-upload
			  		  class="avatar-uploader"
			  		  :action="update_url+'/common/upload'"
			  		  :show-file-list="false"
			  		  :on-success="handleVoucherSuccess"
			  		  :before-upload="beforeVoucherUpload">
						 <el-image v-if="rechargeForm.voucherUrl"
						      class="avatar" style="width:100px; height:100px; display:block;"
						      :src="rechargeForm.voucherUrl"
						      fit="cover"></el-image>
					   <el-button v-else size="small" plain type="primary">이미지 업로드</el-button>
			  		</el-upload>
				</el-form-item>
				<div style="color:#F56C6C; font-size:13px;padding:0 10px;">※ 평일 8:30~17:30에는 보통 30분 이내에 신속하게 심사 처리되며, 휴일에는 처리 시간이 다소 소요될 수 있으니 양해 부탁드립니다.</div>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="rechargeVisible = false">취소</el-button>
				<el-button type="primary" @click="submitRecharge">신청하기</el-button>
			</div>
		</el-dialog>

		<el-dialog title="환전 신청 (KRW -> CNY)" :visible.sync="exchangeVisible" :close-on-click-modal="false" :close-on-press-escape="false" :width="isMobile?'90%':'500px'">
			<div v-if="exchangeResult.exchange_rate > 0" style="background:#f5f8fd; padding:15px; border-radius:10px; margin-bottom:20px; text-align:center;">
				<h4 style="margin:0 0 10px; color:#0055d4;">현재 적용 환율</h4>
				<div style="font-size:16px; font-weight:bold;">
					{{ exchangeResult.exchange_rate }} KRW = 1 CNY
				</div>
				<!-- <div style="font-size: 12px; color: #999; margin-top: 5px;">
					(환전 마진율: {{ exchangeResult.markup }} 포함)
				</div> -->
			</div>
			<el-form :model="exchangeForm" label-width="120px">
				<el-form-item label="신청금액(KRW)" required>
					<el-input v-model="exchangeForm.amount" type="number" placeholder="환전할 한화 금액" @input="calculateExchange" @change="calculateExchange"></el-input>
				</el-form-item>
				<el-form-item label="예상 수령액(CNY)">
					<el-input :value="exchangeResult.target_amount" disabled></el-input>
				</el-form-item>
				<el-form-item label="비고">
					<el-input v-model="exchangeForm.remark" placeholder="추가 전달사항이 있다면 입력해주세요"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="exchangeVisible = false">취 소</el-button>
				<el-button type="primary" @click="submitExchange">신청하기</el-button>
			</div>
		</el-dialog>
		
	</div>
	
	
</template>

<script>
import request from '@/utils/request'
import { safePush } from '@/utils/router';
import ReviewWriteble from '../personal/ReviewWriteble.vue';
import AgencyInvoiceWrite from './AgencyInvoiceWrite.vue';
import InventoryGuide from '../business/InventoryGuide.vue';
import Nodata from './Nodata.vue';
import AgencyList from './AgencyList.vue';
import InventoryList from './InventoryList.vue';
import InventoryWrite from '../inventory/InventoryWrite.vue';
import ItemXlsUpload from '../inventory/ItemXlsUpload.vue';
import InventoryItem from '../inventory/InventoryItem.vue';
import WarehouseWrite from '../inventory/WarehouseWrite.vue';
import WarehouseXlsUpload from '../inventory/WarehouseXlsUpload.vue';
import InventoryWarehouse from '../inventory/InventoryWarehouse.vue';
import InventoryWarehouseComplete from '../inventory/InventoryWarehouseComplete.vue';
import InventoryPackingWrite from '../inventory/InventoryPackingWrite.vue';
import PackingXlsUpload from '../inventory/PackingXlsUpload.vue';
import InventoryPacking from '../inventory/InventoryPacking.vue';

import Constants from "@/constants";
	export default {
		components: {
			ReviewWriteble,
		AgencyInvoiceWrite,
		InventoryGuide,
		Nodata,
		AgencyList,
		InventoryList,
		InventoryWrite,
		ItemXlsUpload,
		InventoryItem,
		WarehouseWrite,
		WarehouseXlsUpload,
		InventoryWarehouse,
		InventoryWarehouseComplete,
		InventoryPackingWrite,
		PackingXlsUpload,
		InventoryPacking,
		},
		data() {
			return {
				activeMenu: this.$route.query.activeMenu || 'default',
				expandedGroups: {
					product: false,
					inbound: false,
					outbound: false
				},

				SERVER_URL: Constants.SERVER_URL,
				update_url: Constants.BASE_URL,
				rechargeVisible: false,
				exchangeVisible: false,
				exchangeForm: {
					amount: '',
					remark: ''
				},
				exchangeResult: {
					target_amount: 0,
					exchange_rate: 0,
					markup: 0
				},
				// --- 自定义统计框(CountBox)下拉吸顶(Affix)悬浮所需状态 ---
				countBoxStyle: {
					position: 'sticky',
					top: '124px',
					zIndex: 100,
					padding: '10px 0px',
					background: 'rgba(255, 255, 255, 0.9)',
					backdropFilter: 'blur(8px)',
					width: '100%',
					left: 'auto'
				},
				isCountBoxFixed: false, // 标记统计框当前是否处于 fixed 状态
				// -----------------------------------------------------
				rechargeForm: {
					currency: 'KRW',
					post_id: '',
					amount: '',
					remitter_name: '',
					remittance_date: '',
					voucher_image: '',
					voucherUrl: ''
				},
				searchForm: {
				  s: '',
				  k: '',
				  //orderType:'',
				  //customsInfoValid:'',
				  deliveryLock:'',
				  date1: '',
				  date2: '',
				},
				status:"",//AADA
				current_status_name:"전체리스트",
				deliveryCenterCode:"",
				
				total:0,
				current_page:1,
				last_page:1,
				page:1,
				tableData: [
					// {
					// date: '2016-05-02',
					// name: '王小虎',
					// address: '上海市普陀区金沙江路 1518 弄',
					// num:'P123456789'
				 //  }, {
					// date: '2016-05-04',
					// name: '王小虎1',
					// address: '上海市普陀区金沙江路 1517 弄',
					// num:'P333333333'
				 //  }, {
					// date: '2016-05-01',
					// name: '王小虎4',
					// address: '上海市普陀区金沙江路 1519 弄'
				 //  }, {
					// date: '2016-05-03',
					// name: '王小虎',
					// address: '上海市普陀区金沙江路 1516 弄',
					// num:'P3232323232324434'
					// },
				],
				user_info:{},
				statistics:{},
				item_num:{},
				orders:{},
				  
				dialogFormVisible: false,
				viewingDetailsId: null,
				info:{},
				editVisible:false,
				form: {
					id:'',
					goods_name:"",
					code:"",
					refer_code:"",
					order_no:"",
					//tracking_no:"",
					apply_quantity:"",
					shipping_memo:"",
					ship_name:""				
				},
				trackingnoVisible:false,
				tracking_no:"",
				//timer: "", // 定时器实例，用于销毁时清除
				edit_button:true,//是否显示编辑按钮
				
				
				
				//unreadCount: 0, // 未读消息数量
				websocket: null, // WebSocket实例
				//userId: localStorage.getItem('uid') || '', // 当前登录用户ID（根据你的实际存储方式调整）
				wsUrl: 'wss://admin.goroketgo.com/wss' // WebSocket服务器地址  127.0.0.1  ws://36.133.127.23:8284
			};
		},
		computed: {
			isMobile() {
				  return window.innerWidth <= 768;
			}
		},
		mounted() {
			// 挂载时，监听滚动与窗口大小调整事件，用于统计算据框(count-box)的吸顶功能
			window.addEventListener('scroll', this.handleScroll);
			window.addEventListener('resize', this.updateCountBoxWidth);
		},
		watch: {
			'$route.query.activeMenu': {
				handler(newVal) {
					if (newVal && newVal !== this.activeMenu) {
						this.activeMenu = newVal;
					}
				},
				immediate: true
			}
		},
		beforeDestroy() {
		    // 页面销毁时关闭WebSocket连接
		    if (this.websocket) {
				this.websocket.close();
				console.log("关闭WebSocket连接")
		    }
			// 销毁时，移除事件监听，防止内存泄漏
			window.removeEventListener('scroll', this.handleScroll);
			window.removeEventListener('resize', this.updateCountBoxWidth);
		},
		created() {
			this.getStatistics()
			this.initWebSocket()
			
		},
		methods: {
			/**
			 * 动态更新统计框的宽度与左侧偏移量
			 * 当处于 fixed 定位时，需要根据外层占位框(wrapper)的宽度来保持其原有尺寸，避免脱离文档流导致宽度塌陷
			 */
			updateCountBoxWidth() {
				if (this.isCountBoxFixed && this.$refs.countBoxWrapper) {
					const rect = this.$refs.countBoxWrapper.getBoundingClientRect();
					this.countBoxStyle = {
						position: 'fixed', // 强制脱离文档流，保证可以跨越父级容器到屏幕最底部
						top: '124px', // 避开顶部导航栏
						zIndex: 100,
						padding: '10px 0px',
						background: 'rgba(255, 255, 255, 0.9)',
						backdropFilter: 'blur(8px)', // 苹果风毛玻璃特效
						width: rect.width + 'px', // 同步外层占位器的精确像素宽度
						left: rect.left + 'px'    // 同步外层占位器的精确左侧位置
					};
				}
			},
			/**
			 * 监听页面滚动条
			 * 动态切换 sticky / fixed 定位以实现类似 el-affix 的全局跨父级悬浮功能
			 */
			handleScroll() {
				if (!this.$refs.countBoxWrapper) return;
				const rect = this.$refs.countBoxWrapper.getBoundingClientRect();
				// 124px 为触发吸顶的顶部安全距离（导航栏高度）
				if (rect.top <= 124) {
					// 滚动超出临界点，切换为 fixed 定位
					if (!this.isCountBoxFixed) {
						this.isCountBoxFixed = true;
						this.updateCountBoxWidth();
					}
				} else {
					// 滚动回到临界点之上，恢复为普通 sticky 定位
					if (this.isCountBoxFixed) {
						this.isCountBoxFixed = false;
						this.countBoxStyle = {
							position: 'sticky',
							top: '124px',
							zIndex: 100,
							padding: '10px 0px',
							background: 'rgba(255, 255, 255, 0.9)',
							backdropFilter: 'blur(8px)',
							width: '100%',
							left: 'auto'
						};
					}
				}
			},
			toggleGroup(groupName) {
				this.$set(this.expandedGroups, groupName, !this.expandedGroups[groupName]);
			},
			selectCoupangMenu(menuName) {
				this.activeMenu = menuName;
				this.viewingDetailsId = null;
				if (this.$route.query.activeMenu !== menuName) {
					this.$router.push({ query: { ...this.$route.query, activeMenu: menuName } }).catch(() => {});
				}
			},

			onExchange(e) {
				if(e) e.preventDefault();
				this.exchangeVisible = true;
				this.exchangeForm = { amount: '', remark: '' };
				this.exchangeResult = { target_amount: 0, exchange_rate: 0, markup: 0 };
				
				request.post('/member/Exchange/calculate', { amount: 1 }).then(res => {
					if(res.code == 1) {
						this.exchangeResult.exchange_rate = res.data.exchange_rate;
						this.exchangeResult.markup = res.data.markup;
					}
				});
			},
			calculateExchange() {
				console.log('calculateExchange called with amount:', this.exchangeForm.amount);
				if(!this.exchangeForm.amount) {
					this.exchangeResult = { ...this.exchangeResult, target_amount: 0 };
					return;
				}
				request.post('/member/Exchange/calculate', { amount: this.exchangeForm.amount }).then(res => {
					console.log('calculateExchange res:', res);
					if(res.code == 1) {
						this.exchangeResult = {
							...this.exchangeResult,
							target_amount: res.data.target_amount,
							exchange_rate: res.data.exchange_rate,
							markup: res.data.markup
						};
					}
				});
			},
			submitExchange() {
				if(!this.exchangeForm.amount) {
					this.$message.error('금액을 입력해주세요.');
					return;
				}
				request.post('/member/Exchange/apply', this.exchangeForm).then(res => {
					if(res.code == 1) {
						this.$message.success('신청이 완료되었습니다.');
						this.exchangeVisible = false;
						this.getStatistics();
					} else {
						this.$message.error(res.msg);
					}
				});
			},

			onCybercash(e){
				if(e) e.preventDefault();
				this.rechargeVisible = true;
				this.rechargeForm = {
					currency: 'KRW',
					post_id: '',
					amount: '',
					remitter_name: '',
					remittance_date: '',
					voucher_image: '',
					voucherUrl: ''
				};
			},
			handleVoucherSuccess(res, file) {
				if(res.code == 1) {
					this.rechargeForm.voucherUrl = res.data.fullurl;
					this.rechargeForm.voucher_image = res.data.url;
				} else {
					this.$message.error(res.msg || "업로드 실패");
				}
			},
			beforeVoucherUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG && !isPNG) {
				  this.$message.error('업로드 이미지는 JPG 또는 PNG 형식이어야 합니다!');
				  return false;
				}
				if (!isLt5M) {
				  this.$message.error('업로드 이미지 크기는 5MB를 초과할 수 없습니다!');
				  return false;
				}
				return true;
			},
			submitRecharge() {
				if(!this.rechargeForm.post_id) {
					this.$message.error("회원번호를 입력하세요."); return;
				}
				if(!this.rechargeForm.amount) {
					this.$message.error("충전금액을 입력하세요."); return;
				}
				if(!this.rechargeForm.remitter_name) {
					this.$message.error("입금자명을 입력하세요."); return;
				}
				if(!this.rechargeForm.remittance_date) {
					this.$message.error("입금일자를 선택하세요."); return;
				}
				if(!this.rechargeForm.voucher_image) {
					this.$message.error("입금증명서를 업로드하세요."); return;
				}
				request.post('/member/Cybercash/apply', this.rechargeForm).then(res => {
					if(res.code == 1) {
						this.$message.success("충전 신청이 완료되었습니다. 관리자 확인 후 처리됩니다.");
						this.rechargeVisible = false;
					} else {
						this.$message.error(res.msg || "신청에 실패했습니다.");
					}
				});
			},
			onNav(url){			
				safePush(this.$router, url);
			},
			onPrompt(){
				alert("기대해주세요.(敬请期待)")
			},
			onOrderList(value,name){
				console.log(value,name,"点击..")
				this.viewingDetailsId = null
				if (this.status === value && this.current_status_name === name) {
					this.getList()
					return
				}
				this.status = value
				this.current_status_name = name
				this.page = 1
				this.getList()
				// 同步更新 URL 以支持浏览器后退และ刷新
				const query = { ...this.$route.query, status: value, name: name };
				this.$router.push({ query }).catch(() => {});
			},
			onChangeDeliveryCenter(code) {
				console.log(code, "切换分拨中心")
				this.viewingDetailsId = null
				if (this.deliveryCenterCode === code) {
					this.deliveryCenterCode = "" // 再次点击取消筛选
				} else {
					this.deliveryCenterCode = code
				}
				this.page = 1
				this.getList()
				// 同步更新 URL
				const query = { ...this.$route.query, deliveryCenterCode: this.deliveryCenterCode };
				if (!this.deliveryCenterCode) delete query.deliveryCenterCode;
				this.$router.push({ query }).catch(() => {});
			},
			closeDetailDialog(){
				this.edit_button = true
			},
			handleEdit(index, row) {
				console.log(index, row);
				if(row.data_type == "agency"){//代理
					this.edit_button = false
				}
				this.form = row
				this.viewingDetailsId = row.id
				this.getGoodsInfo(row.id,row.data_type)
				
				this.$nextTick(() => {
					window.scrollTo({ top: 0, behavior: 'smooth' });//平滑回滚
				});
			},
			handleModifyAgencyOrder(row) {
				console.log("Modify Agency Order 修改代理订单:", row);
				if (row.agency_type == '2') {
					safePush(this.$router, `/agencyShoppingEdit?id=${row.agency_id}`);
				} else {
					safePush(this.$router, `/agencyShippingEdit?id=${row.agency_id}`);
				}
			},
			closeDetails() {
				this.viewingDetailsId = null
				this.info = {}
				this.edit_button = true
			},
			handleDelete(index, row) {
				console.log(index, row);
				console.log(row.id)
				this.$confirm('정말 삭제하겠습니까?', '', {
				  confirmButtonText: '확인',
				  cancelButtonText: '취소',
				  type: 'warning'
				}).then(() => {
					request.post('/member/Inventory/deleteWarehouse',{
						id:row.id
					}).then(res => {
						console.log(res,"")
						if(res.code ==1){
							this.$message({
								type: 'success',
								message: '삭제 성공!'
							});
							this.page = 1
							this.getList()
						}		
					});		
				}).catch(() => {     
				});
				
			},
			getGoodsInfo(id,data_type){
				console.log(id,2222)
				request.post('/member/Inventory/getGoodsInfo',{
					id:id,
					data_type:data_type
				})
				.then(res => {
					if(res.code ==1){
						this.info = res.data
						this.info.data_type = data_type
						console.log(this.info,"详细信息")
					}		
				});
				
			},
			handleTrackingno(index, row){
				console.log(index, row)
				console.log(row.data_type)
				this.form = row
				this.trackingnoVisible = true
				if(row.apply_id){
					this.getGoodsInfo(row.apply_id,row.data_type)
				}else{
					this.getGoodsInfo(row.id,row.data_type)
				}

			},
			onSubmit() {
				// request.post('',
				// 	{
						
				// 	}
				// ).then(response => {
				// 	console.log(response,"form")
				// 	if(response.code ==1){
					
				// 	}else{
					
				// 	}
						
				// });
				console.log(this.searchForm,'submit!');
				this.viewingDetailsId = null;
				this.getList();
				
			},
			onReset(){
				this.searchForm= {
				  s: '',
				  k: '',
				  deliveryLock:'',
				  date1: '',
				  date2: '',
				},
				this.viewingDetailsId = null;
				this.page = 1
				this.getList()
			},
			getList(){
				request.post('/Order/orderbundleList',
					{
						page:this.page,
						status:this.status,
						search:this.searchForm,
						deliveryCenterCode: this.deliveryCenterCode,
					}
				).then(res => {
					console.log(res,"订单")
					if(res.code ==1){
						this.total = res.data.total
						this.current_page = res.data.current_page
						this.last_page = res.data.last_page
						this.tableData= res.data.rows
					}else{
					
					}
						
				});
			},
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
			getUserInfo(){
				request.post('/User/getUserInfo',{}
				).then(res => {
					console.log(res,"列表")
					if(res.code ==1){
						this.user_info= res.data
					}		
				});
			},
			getItemNum(){
				request.post('/User/getItemNum',{}
				).then(res => {
					console.log(res,"必须确认的事项数量")
					if(res.code ==1){
						this.item_num = res.data
					}		
				});
			},
			getStatistics(){
				request.post('/User/getStatistics',{}
				).then(res => {
					console.log(res,"统计数据")
					if(res.code ==1){
						this.statistics= res.data
					}		
				});
			},
			getOrderLog(){
				request.post('/Order/getOrderLog',{}
				).then(res => {
					console.log(res,"统计订单记录")
					if(res.code ==1){
						this.orders= res.data
					}		
				});
				
			},
			submitTrackingno(){
				console.log(this.info.id,"_id")
				console.log(this.info.data_type,"data_type")
				if(this.tracking_no==""){
					alert("트래킹넘버 필수")
					return
				}
				request.post('/member/Inventory/addTrackingno',
					{
						tracking_no:this.tracking_no,
						id:this.info.id,
						data_type:this.info.data_type
					}
				).then(response => {
					console.log(response,"")			  
					if(response.code ==1){
						alert('수정 성공！');
						this.tracking_no = ""
						this.trackingnoVisible = false
						this.getList();
						console.log('提交成功！');
					}else{
						alert("실패")
						return
					}						
				});			
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log(this.form,222221111)
						request.post('/member/Inventory/editWarehouse',
							this.form
						).then(response => {
							console.log(response,"")			  
							if(response.code ==1){
								alert('수정 성공！');
								this.editVisible = false
								this.getList();
								console.log('提交成功！');
							}else{
								alert("실패")
								return
							}						
						});				
					}	
				})
			},
			onEdit(){
				console.log("编辑弹框")
				this.editVisible = true
			},
			 /**
			 * 初始化WebSocket连接
			 */
			initWebSocket() {
			 //  if (!window.WebSocket) {
				// alert('你的浏览器不支持WebSocket，请升级浏览器');
				// return;
			 //  }
			  
			  // 创建WebSocket连接
			  this.websocket = new WebSocket(this.wsUrl);
			  
			  // 连接成功回调
			  this.websocket.onopen = () => {
				console.log('WebSocket连接成功');
				// 连接成功后，将当前连接绑定到用户ID（关键：和后端推送的uid对应）
				this.websocket.send(JSON.stringify({
				  type: 'bind_uid',
				  uid: localStorage.getItem('user_id')
				}));
			  };
			  
			  // 接收消息回调
			  this.websocket.onmessage = (e) => {
				try {
				  const res = JSON.parse(e.data);
				  console.log(res,"返回了")
				  // 判断消息类型，更新数量
				  if (res.type === 'single_count') {
					  console.log(res,"返回了2222")
						this.statistics.message_num = res.message_num;
						this.statistics.unread_message_num = res.unread_message_num;
				  }else if(res.type === 'multiple_count'){
					  this.statistics.message_num += 1;
					  this.statistics.unread_message_num += 1;
				  }
				} catch (err) {
				  console.error('解析WebSocket消息失败：', err);
				}
			  };
			  
			  // 连接关闭回调
			  this.websocket.onclose = () => {
				console.log('WebSocket连接关闭，请尝试重连...');
				// 断线重连（可选，提升稳定性）
				// setTimeout(() => {
				//   this.initWebSocket();
				// }, 3000);
			  };
			  
			  // 连接错误回调
			  this.websocket.onerror = (err) => {
				console.error('WebSocket连接错误：', err);
			  };
			},
			
			
			
			
		},
		created() {
			this.nickname=localStorage.getItem('nickname')
		    // 页面加载时初始化WebSocket连接
			this.initWebSocket();
			this.getStatistics()
			this.getUserInfo()
			
			// 从 URL 参数恢复上次的状态，支持新页面打开或刷新
			if (this.$route.query.status) {
				this.status = this.$route.query.status
				this.current_status_name = this.$route.query.name || ''
			}
			
			if (this.$route.query.deliveryCenterCode) {
				this.deliveryCenterCode = this.$route.query.deliveryCenterCode
			}
			
			this.getList()
			this.getOrderLog()
			this.getItemNum()
			
			// 启动定时器：每秒执行一次
			// this.timer = setInterval(() => {
			//   this.getStatistics()
			// }, 2000); // 1000 毫秒 = 1 秒
		},
		  // beforeDestroy() {
		  //   // 组件销毁前清除定时器，避免内存泄漏
		  //   clearInterval(this.timer);
		  //   this.timer = "";
		  // },
	  
	}
</script>

<style scoped>
	.navi {
	    margin-right: 40px;
	}
	.widget-sub-navi-mypage h2 {
	    font-size: 30px;
	    font-weight: bold;
	    margin: 0 0 30px;
	}
	.widget-sub-navi-mypage .box {
	    min-height: 250px;
	    padding: 20px;
	    border: 1px solid var(--border-color);
	    border-radius: 24px;
	    margin-bottom: 40px;
	    background: #fff;
	}
	.widget-sub-navi-mypage .info {
	    font-size: 17px;
	    position: relative;
	    margin-bottom: 14px;
	    display: flex;
	    align-items: center;
		color: var(--background-color);
	}
	.widget-sub-navi-mypage .level-icon {
	    vertical-align: middle;
	    margin-right: 8px;
	    width: 40px;
	    height: 40px;
	    border-radius: 10px;
	    border: 1px solid var(--border-color);
	    display: flex;
	    align-items: center;
	    justify-content: center;
	}
	.widget-sub-navi-mypage .group {
	    display: flex;
	    margin-bottom: 14px;
	    align-items: center;
	}
	.widget-sub-navi-mypage .group .left {
	    flex: 1 1 auto;
	    color: #5a5a5a;
	    font-size: 14px;
	    letter-spacing: -0.5px;
	}
	.widget-sub-navi-mypage .level {
	    margin-bottom: 4px;
	    display: flex;
	    align-items: center;
	}
	.widget-sub-navi-mypage .link {
	    flex: 0 0 110px;
	}
	.widget-sub-navi-mypage .link a {
	    display: block;
	    font-size: 13px;
	    font-weight: bold;
	    color: #000;
	    background: #eff3f9;
	    border-radius: 44px;
	    text-align: center;
	    width: 100%;
	    height: 36px;
	    line-height: 36px;
	    text-decoration: none;
	}
	.widget-sub-navi-mypage .msg {
	    height: 57px;
	    padding: 0 10px 0 40px;
	    border: 1px solid #e8e8e8;
	    border-radius: 14px;
	    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
	    color: #000;
	    font-size: 15px;
	    font-weight: bold;
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    position: relative;
	}
	.widget-sub-navi-mypage .msg:before {
	    content: '';
	    display: block;
	    width: 24px;
	    height: 25px;
	    position: absolute;
	    left: 10px;
	    top: 15px;
	    background: url("../../assets/icon/ico_msg.png") no-repeat 0 0;
	}
	.widget-sub-navi-mypage .msg strong {
	    color: #e80741;
	}
	.widget-sub-navi-mypage .msg a {
	    color: #fff;
	    font-weight: normal;
	    font-size: 14px;
	    background: #e80741;
	    border-radius: 4px;
	    width: 70px;
	    height: 37px;
	    line-height: 38px;
	    display: block;
	    text-align: center;
	    text-decoration: none;
		cursor: pointer;
	}
	.count-box {
	    display: flex;
	    align-items: center;
	    gap: 10px;
	    margin-bottom: 20px;
	}
	.count-box .unit {
	    border: 1px solid var(--border-color);
	    border-radius: 14px;
	    flex: 1;
	    text-align: center;
	    overflow: hidden;
	    background: #fff;
	}
	.count-box .title {
	    background: #000;
	    color: #fff;
	    font-weight: bold;
	    font-size: 15px;
	    height: 44px;
	    line-height: 44px;
	}
	.count-box .content {
	    height: 70px;
	    line-height: 70px;
	    border-bottom: 1px solid var(--border-color);
	    font-size: 24px;
	    font-weight: bold;
	    color: #5a5a5a;
	}
	.count-box .link {
	    height: 42px;
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	}
	.count-box .link a {
	    color: #6a6a6a;
	    width: 100%;
	    height: 100%;
	    display: block;
	    text-decoration: none;
	    line-height: 42px;
	    font-size: 15px;
	}
	.count-box .link a + a {
	    border-left: 1px solid var(--border-color);
	}
	
	.need-box {
	    margin-bottom: 50px;
	}
	.need-box .unit {
	    display: flex;
	    align-items: center;
	    border: 1px solid var(--border-color);
	    border-radius: 14px;
	    overflow: hidden;
	    background: #fff;
	}
	.need-box .title {
	    height: 56px;
	    line-height: 56px;
	    text-align: center;
	    flex: 0 0 125px;
	    background: #000;
	    color: #fff;
	    font-size: 15px;
	    font-weight: bold;
	}
	.need-box .content {
		display: flex;
		flex: 1 1 auto;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;
		font-weight: bold;
		color: #5a5a5a;
		padding: 0 14px;
	}
	.need-box ul {
	    list-style: none;
	    padding: 0;
	    margin: 0;
	}
	.need-box li {
	    display: inline-block;
	    margin-right: 15px;
	}
	.need-box span {
	    color: #bcbcbc;
	    margin-left: 6px;
	}
	.menu-box {
	    margin-bottom: 40px;
	}
	.menu-box ul {
	    list-style: none;
	    padding: 0;
	    margin: 0;
	}
	.menu-box li {
	    border: 1px solid var(--border-color);
	    border-radius: 20px;
	    background: #eff3f9;
	    margin-bottom: 10px;
	    position: relative;
	    overflow: hidden;
	}
	.menu-box li a {
	    padding: 13px 40px 13px 54px;
	    text-decoration: none;
	    font-size: 17px;
	    font-weight: bold;
	    display: block;
	    color: var(--main-color);
	    position: relative;
		cursor: pointer;
	}
	.menu-box li a:before {
	    content: '';
	    display: block;
	    width: 24px;
	    height: 26px;
	    position: absolute;
	    left: 20px;
	    top: 13px;
	    background-repeat: no-repeat;
	    background-position: 0 0;
	}
	.menu-box li:after {
	    content: '';
	    display: block;
	    width: 16px;
	    height: 16px;
	    position: absolute;
	    right: 20px;
	    top: 17px;
	    background: url("../../assets/icon/order_menu_arrow.png") no-repeat 0 50%;
	}
	.menu-box li.menu-all a:before {
	    background-image: url("../../assets/icon/ico_biz_shopping.png");
	}
	.menu-box li.menu-review a:before {
	    background-image: url("../../assets/icon/order_menu_review.png");
	}
	.menu-box li.menu-pay a:before {
	    background-image: url("../../assets/icon/order_menu_pay.png");
	}
	.menu-box li.menu-inventory a:before {
	    background-image: url("../../assets/icon/order_menu_inventory.png");
	}
	.menu-box li.menu-nodata a:before {
	    background-image: url("../../assets/icon/order_menu_tracking.png");
	}
	.menu-box li.menu-agency a:before {
	    background-image: url("../../assets/icon/agency.png");
	}
	.menu-box li.menu-coupang-delivery a:before {
	    background-image: url("../../assets/icon/list_menu_inventory.png");
	}
	.menu-box li.menu-recharge a:before {
	    background-image: url("../../assets/icon/order_menu_cash.png");
	}

	.widget-agency-mypage-report {
	    margin-bottom: 20px;
	}
	.widget-agency-mypage-report h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 0 0 0 10px;
	    margin: 0 0 14px;
	    position: relative;
	}
	.widget-agency-mypage-report h3:before {
	    content: '';
	    display: block;
	    width: 3px;
	    height: 24px;
	    background: var(--frontground-color);
	    position: absolute;
	    left: 0;
	    top: 0;
	}
	.widget-agency-mypage-report .wrap {
	    display: flex;
	    border: 1px solid #e8e8e8;
	    border-radius: 20px;
	    overflow: hidden;
	    background: #fff;
	}
	.widget-agency-mypage-report .unit {
	    flex: 0 0 20%;
	    position: relative;
	}
	.widget-agency-mypage-report .unit.crash h4 {
	    background-color: #f7941d;
	}
	.widget-agency-mypage-report h4 {
	    background: #000;
	    font-size: 17px;
	    font-weight: bold;
	    color: #fff;
	    height: 44px;
	    line-height: 44px;
	    margin: 0;
	    position: relative;
	    padding: 0 0 0 70px;
	}
	.widget-agency-mypage-report h4:before {
	    content: '';
	    display: block;
	    width: 25px;
	    height: 26px;
	    position: absolute;
	    left: 35px;
	    top: 9px;
	    background-position: 0 50%;
	    background-repeat: no-repeat;
	}
	.widget-agency-mypage-report .unit:nth-of-type(1) h4:before {
	    background-image: url("../../assets/icon/shopping.png");
	}
	.widget-agency-mypage-report .unit:nth-of-type(2) h4:before {
	    background-image: url("../../assets/icon/shipping.png");
	}
	.widget-agency-mypage-report .unit:nth-of-type(3) h4:before {
	    background-image: url("../../assets/icon/delivery.png");
	}
	.widget-agency-mypage-report .unit:nth-of-type(4) h4:before {
	    background-image: url("../../assets/icon/carsh.png");
	}
	.widget-agency-mypage-report .unit:nth-of-type(5) h4:before {
	    background-image: url("../../assets/icon/return.png");
	}
	.widget-agency-mypage-report .unit .box {
	    height: 240px;
	    padding-top: 15px;
	}
	.widget-agency-mypage-report .table-mypage-report {
	    width: 100%;
	    border-spacing: 0;
	    border-collapse: collapse;
	}
	.widget-agency-mypage-report .table-mypage-report a{
		cursor: pointer; /* 鼠标悬停时显示手型 */
	}
	.widget-agency-mypage-report .table-mypage-report th, .widget-agency-mypage-report .table-mypage-report td {
	    padding: 3px 20px;
	    vertical-align: middle;
	    text-align: center;
	}
	.widget-agency-mypage-report .table-mypage-report td .view-group.active .view-group-addon {
	    color: #0055d4;
	}
	.widget-agency-mypage-report .table-mypage-report td .view-group.active .view-group-basic {
	    color: #0055d4;
	    font-weight: bold;
	}
	.widget-agency-mypage-report .table-mypage-report td a {
	    display: block;
	    color: #5a5a5a;
	    padding: 4px 0;
	    font-size: 15px;
		text-decoration: none;
	}
	.view-group .view-group-basic {
	    display: table-cell;
	    position: relative;
	    width: 100%;
	    z-index: 2;
	}
	.view-group .view-group-addon {
	    display: table-cell;
	    width: 1%;
	    white-space: nowrap;
	    vertical-align: middle;
	    text-align: center;
		font-weight: bold;
	}
	.search-box {
	    overflow: hidden;
	    border: 1px solid #e8e8e8;
	    border-radius: 12px;
	    margin-bottom: 24px;
	    padding: 24px 28px 16px;
	    background: #f8f9fa;
	}
	.search-box__grid {
	    display: grid;
	    grid-template-columns: 1fr 1fr;
	    gap: 16px 24px;
	    align-items: start;
	}
	.search-box__field {
	    display: flex;
	    align-items: center;
	    gap: 12px;
	}
	.search-box__label {
	    font-size: 13px;
	    font-weight: 600;
	    color: #333;
	    white-space: nowrap;
	    min-width: 65px;
	    text-align: right;
	}
	.search-box__input-group {
	    display: flex;
	    gap: 8px;
	    flex: 1;
	}
	.search-box__select {
	    width: 160px !important;
	    flex-shrink: 0;
	}
	.search-box__keyword {
	    flex: 1;
	}
	.search-box__select--full {
	    width: 100% !important;
	    flex: 1;
	}
	.search-box__date-range {
	    display: flex;
	    align-items: center;
	    gap: 8px;
	    flex: 1;
	}
	.search-box__date-sep {
	    color: #999;
	    font-size: 14px;
	    flex-shrink: 0;
	}
	.search-box__actions {
	    display: flex;
	    justify-content: flex-end;
	    align-items: flex-end;
	    gap: 8px;
	    padding-top: 4px;
	}
	.search-box__btn-search {
	    background: #ff6a00 !important;
	    border-color: #ff6a00 !important;
	    color: #fff !important;
	    font-weight: 600;
	    padding: 8px 28px !important;
	    border-radius: 6px !important;
	    font-size: 13px !important;
	    height: 36px !important;
	    transition: all 0.2s;
	}
	.search-box__btn-search:hover {
	    background: #e55d00 !important;
	    border-color: #e55d00 !important;
	}
	.search-box__btn-reset {
	    background: #fff !important;
	    border: 1px solid #d0d0d0 !important;
	    color: #666 !important;
	    font-weight: 500;
	    padding: 8px 20px !important;
	    border-radius: 6px !important;
	    font-size: 13px !important;
	    height: 36px !important;
	    transition: all 0.2s;
	}
	.search-box__btn-reset:hover {
	    border-color: #aaa !important;
	    color: #333 !important;
	}
	/* Unified input/select/datepicker styling inside search-box */
	.search-box .el-input__inner,
	.search-box .el-select .el-input__inner,
	.search-box .el-date-editor .el-input__inner {
	    height: 34px !important;
	    line-height: 34px !important;
	    border-radius: 6px !important;
	    border-color: #d0d5dd !important;
	    font-size: 13px !important;
	}
	.search-box .el-input__inner:focus,
	.search-box .el-select .el-input__inner:focus {
	    border-color: #ff6a00 !important;
	}
	.search-box .el-form-item {
	    margin-bottom: 0 !important;
	}
	
	.event-change-agency-list {
	    background: rgb(247, 148, 29);
	    margin: 0 0 30px;
	}
	.event-change-agency-list ul {
	    display: flex;
	    list-style: none;
	    padding: 0;
	    margin: 0;
	}
	.event-change-agency-list ul li {
	    flex: 1;
	    position: relative;
	}
	.event-change-agency-list ul li a {
	    color: #fff;
	    font-weight: bold;
	    text-align: center;
	    padding: 17px 0;
	    position: relative;
	    text-decoration: none;
		display: block;
		cursor: pointer;
	}
	.event-change-agency-list ul li.type-cn_ship a:before {
	    content: '';
	    display: inline-block;
	    background: url("../../assets/icon/order_center_ship.png") no-repeat 0 0;
	    width: 23px;
	    height: 24px;
	    vertical-align: middle;
	    margin-bottom: 2px;
	    margin-right: 5px;
	}
	.event-change-agency-list ul li.type-cn_air a:before {
	    content: '';
	    display: inline-block;
	    background: url("../../assets/icon/order_center_air.png") no-repeat 0 0;
	    width: 25px;
	    height: 24px;
	    vertical-align: middle;
	    margin-bottom: 2px;
	    margin-right: 5px;
	}
	.list-top {
		flex-wrap: wrap;
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    margin-bottom: 20px;
	}
	.list-top .current-status {
	    flex: 0 0 100%;
	    font-size: 22px;
	    font-weight: bold;
	    padding: 0;
	    margin: 0 0 30px;
	}
	/* 让父组件的样式能够影响到子组件使用 ::v-deep 穿透 scoped 样式，修改表头文字颜色 (父组件的样式能够影响到子组件) */
	::v-deep .el-table__header th {
	  color: #333; 
	  font-size: 17px;
	  font-weight: bold;
	  padding: 12px 0;
	}
	::v-deep .el-table__header th .cell {
		text-align: center; /* 核心样式：设置表头文字居中 */
	}
	::v-deep .el-table__body td .cell {
		 font-size: 16px;
		text-align: center;
		padding: 10px 5px;
	}
	::v-deep .el-button--mini {
	    padding: 8px 12px;
		font-size: 14px;
	}
	::v-deep .el-button+.el-button {
	    margin:5px 0 0 2px;
	}
	.page{
		padding-top: 20px;
		text-align: center;
	}
	.link a{
		cursor: pointer;
	}
	/*弹框 详情*/
	.table-title{
		background-color: #f5f8fd;border-top: 1px solid #e3e3e3;border-bottom: 1px solid #e3e3e3;font-size: 15px;min-height: 75px;display: flex;justify-content: center;align-items: center;
	}
	.table-content{
		border: 1px solid #e3e3e3;font-size: 14px;height: 75px;padding:0 10px;display: flex;align-items: center;overflow: hidden;
	}
	.table-content a{
		text-decoration: none;
		color: #337ab7;
	}
	/* 弹框表单 */
	.form-item .item{
		display: flex;
		align-items: center; 
		/* padding-bottom: 20px; */
	}
	.from-title{
		width: 125px;
		padding-bottom: 20px;
	}
	.input-frame{
		width: 200px;
		margin: 0 10px;
	}
	.required-addon{
		font-family: inherit;
		color: var(--main-color);
		font-weight: inherit;
		vertical-align: inherit;
	}
	.icon-question{
		color:var(--main-color);padding-left: 5px;font-size: 18px;
	}
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.content-zsy{
			padding:40px 10px;
		}
		.count-box {
			display: block;
		    margin-bottom: 20px;
		}
		.count-box .content {
		    font-size: 15px;
		    font-weight: bold;
		    color: var(--font-color);
		}
		.count-box .group {
		    display: flex;
		    gap: 10px;
		    margin-bottom: 10px;
		}
		.count-box .group .content {
		    height: 40px;
		    line-height: 40px;
		}
		.count-box .unit {
		    border: 1px solid var(--border-color);
		    border-radius: var(--border-radius);
		    flex: 1;
		    text-align: center;
		    overflow: hidden;
		    background: #fff;
		}
	
		.count-box .content a {
		    height: 34px;
		    line-height: 34px;
		    padding: 0 10px;
		    display: inline-block;
		    font-size: 13px;
		    font-weight: normal;
		    text-decoration: none;
		    border-radius: 10px;
		    margin-left: 15px;
		    color: var(--font-color);
		    border: 1px solid var(--border-color);
		}
		.count-box .link {
		    height: 34px;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    border-top: 1px solid var(--border-color);
		}
		.count-box .link a {
		    color: var(--font-color);
		    width: 100%;
		    height: 100%;
		    display: block;
		    text-decoration: none;
		    line-height: 34px;
		}
		.need-box .unit {
			display:block;
		    border: 1px solid var(--border-color);
		    border-radius: var(--border-radius);
		    overflow: hidden;
		    background: #fff;
		}
		.need-box .title {
		    height: 30px;
		    line-height: 30px;
		    text-align: center;
		    flex: 0 0 125px;
		    background: #000;
		    color: #fff;
		    font-weight: bold;
		}
		.need-box .content {
		    padding: 10px 14px;
			font-size: 12px;
		}
		.need-box ul {
		    list-style: none;
		    padding: 14px;
		    margin: 0 0 14px;
		    display: flex;
		    border: 1px solid #d9d9d9;
		    border-radius: 14px;
		    background: #f7f8fa;
		    gap: 20px;
		    color: var(--font-color);
		}
		.need-box li {
		    flex: 1;
		    text-align: center;
		    font-weight: bold;
			 margin-right: 0;
			 width: 90px;
		}
		.need-box span {
		    display: block;
		    color: #bcbcbc;
		    margin-top: 5px;
		}
		.widget-agency-mypage-report .wrap {
			display: block;
			border: none;
		}
		.widget-agency-mypage-report .unit {
		    border: 1px solid var(--border-color);
		    border-radius: var(--border-radius);
		    overflow: hidden;
		    display: flex;
		    align-items: center;
		    position: relative;
		}
		.widget-agency-mypage-report .unit:before {
		    content: '';
		    display: block;
		    width: 90px;
		    height: 100%;
		    background: #f7941d;
		    position: absolute;
		    left: 0;
		    top: 0;
		}
		.widget-agency-mypage-report h4 {
		    position: relative;
		    flex: 0 0 90px;
		    margin: 0;
		    font-size: 15px !important;
		    font-weight: bold;
		    color: #fff;
		    padding-left: 30px;
		    letter-spacing: -0.5px;
		}
		.widget-agency-mypage-report ul {
			font-size: 12px;
		    flex: 1;
		    display: flex;
		    flex-wrap: wrap;
		    gap: 0 15px;
		    list-style: none;
		    padding: 10px;
		    margin: 0;
		    background: #fff;
		}
		.widget-agency-mypage-report li a {
		    text-decoration: none;
		    color: var(--font-color);
		}
		.view-group {
		    position: relative;
		    width: 100%;
		    display: table;
		    border-collapse: separate;
		}
		.view-group.active .view-group-basic, .view-group.active .view-group-addon {
		    color: #0055d4 !important;
		    font-weight: bold;
		}
		.widget-agency-mypage-report li .view-group-basic {
		    width: 55px;
		}
		.widget-agency-mypage-report .crash li .view-group-basic {
		    width: 80px;
		}
		.view-group .view-group-basic {
		    display: table-cell;
		    position: relative;
		    width: 100% !important;
		    z-index: 2;
		}
		.widget-agency-mypage-report li .view-group-addon {
		    text-align: right;
		    width: 30px;
		}
		.view-group .view-group-addon {
		    display: table-cell;
		    width: 1%;
		    white-space: nowrap;
		    vertical-align: middle;
		    text-align: center;
		}
		.widget-agency-mypage-report h4:before {
		    content: '';
		    display: block;
		    width: 15px;
		    height: 16px;
		    position: absolute;
		    left: 10px;
		    top: 50%;
		    transform: translateY(-50%);
		    background-position: 0 50%;
		    background-size: contain;
		    background-repeat: no-repeat;
		}
		.widget-agency-mypage-report .unit + .unit {
		    margin-top: 5px;
		}
		.widget-agency-mypage-report .unit.crash:before {
		    background-color: #f7941d;
		}
		/*底部列表*/
		.order-item-list .group {
		    padding: 20px;
		    border: 1px solid var(--border-color);
		    background: #fff;
		    margin-top: -1px;
		    border-radius: 14px;
			margin-bottom: 10px;
		}
		.order-item-list .order-info-wrap {
		    display: flex;
		    gap: 0 10px;
		    margin-bottom: 7px;
		}
		.order-item-list .link-wrap .btn.type-blue {
		    background-color: var(--secondary-color);
		    border-color: var(--secondary-color);
		    color: #fff;
		}
		.order-item-list .link-wrap .btn {
		    border-radius: 10px;
		    min-width: 65px;
		    padding: 0;
		    text-align: center;
		    background: #f2f3f3;
		    border-color: #f2f3f3;
		    color: var(--font-color);
		    font-size: 12px;
		    font-weight: 500;
		    margin-right: 6px;
		}
		a.btn-sm {
		    line-height: 28px;
		    padding: 0 10px;
		    vertical-align: bottom;
		    display: inline-block;
			height: 30px;
			text-decoration: none;
		}
		.order-item-list .link-wrap {
		    border-bottom: 1px solid var(--border-color);
		    padding-bottom: 10px;
		    margin-bottom: 10px;
		}
		.order-item-list .thumb-box {
		    flex-basis: 90px;
		    width: 90px;
			flex: 0 0 100px;
		}
		.order-item-list .thumb-box .thumb {
		    height: 90px;
			height: 100px;
			border: 1px solid #e0e0e0;
			background: #fff;
			border-radius: var(--border-radius);
			overflow: hidden;
			display: flex;
			align-items: center;
			justify-content: center;
			
		}
		.order-item-list .thumb-box .no-thumb {
			background: url("../../assets/no_thumb.png") no-repeat 50% 50% #f4f4f4;
		}
		.order-item-list .order-info-wrap .info {
		    flex: 1;
		    letter-spacing: -.5px;
		}
		.label-warehouse {
		    color: #5cb85c;
		}
		.label-type {
		    padding: 0;
		    vertical-align: baseline;
		}
		.label ,.status {
		    font-size: 12px;
		}
		.order-item-list .goodsname a {
		    color: inherit;
			text-decoration: none;
		}
		.order-item-list .info .unit{
			font-size: 13px;
			color:#333;
			padding-bottom: 2px;
		}
		.order-item-list .order-wrap {
			margin-top: 10px;
		    margin-bottom: 24px;
		}
		.order-item-list .tracking-box {
		    display: flex;
		    align-items: center;
		    border: 1px solid #e8e8e8;
		    background: #eff3f9;
		    border-radius: 10px;
		    padding: 14px;
		    margin-bottom: 10px;
		    flex-wrap: wrap;
		}
		.order-item-list .tracking-box .number {
		    flex: 1;
		    color: #000;
		    padding: 0;
		    position: relative;
		    font-size: 14px;
		}
		.order-item-list .tracking-box .number strong {
		    margin-right: 5px;
		}
		.order-item-list .tracking-box .date {
		    color: #6a6a6a;
		    margin-top: 5px;
		}
		.order-item-list .order-wrap ul {
		    list-style: none;
		    padding: 0;
		    margin: 0;
		}
		.order-item-list .tracking-box .date li {
		    font-size: 13px;
		    margin-right: 5px;
		}
		.order-item-list .order-wrap .center-box {
		    display: flex;
		    gap: 5px;
		}
		.order-item-list .order-wrap .center-box ul {
		    flex: 1;
		    border: 1px solid var(--border-color);
		    background: #eff3f9;
		    color: #000;
		    text-align: center;
		    border-radius: 10px;
		    font-size: 12px;
		    padding: 7px 5px;
		}
		.order-item-list .submit-wrap {
		    display: flex;
		    flex-wrap: wrap;
		    gap: 6px;
			text-align: center;
			padding-top: 14px;
			border-top: 1px solid var(--border-color);
		}
		.order-item-list .submit-wrap .btn {
		    display: block;
		    height: 40px;
		    line-height: 40px;
		    font-weight: bold;
		    border-radius: 10px;
		    border: 1px solid var(--secondary-color);
		    color: var(--secondary-color);
		    background: #fff;
		    padding: 0;
		    flex: 0 0 48%;
		}
		
		
		
	}

/* Coupang Sidebar Styles */
.coupang-menu-title {
    font-size: 15px;
    font-weight: bold;
    color: #ff5700;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 2px solid #ffe8db;
    margin-top: 15px;
}
.coupang-menu-section ul {
    list-style: none;
    padding: 0;
    margin: 0;
}
/* Expandable group items: softer radius to contain sub-menus */
.coupang-group-li.group-product,
.coupang-group-li.group-inbound,
.coupang-group-li.group-outbound {
    border: 1px solid var(--border-color);
    border-radius: 20px;
    background: #eff3f9;
    margin-bottom: 10px;
    position: relative;
    overflow: hidden;
}
.coupang-group-header {
    padding: 13px 40px 13px 60px;
    text-decoration: none;
    font-size: 17px;
    font-weight: bold;
    display: block;
    color: var(--main-color);
    position: relative;
    cursor: pointer;
    transition: all 0.2s ease;
}
.coupang-group-header:before {
    content: '';
    display: block;
    width: 32px;
    height: 32px;
    position: absolute;
    left: 18px;
    top: 10px;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: contain;
}
.coupang-group-li.group-product .coupang-group-header:before {
    background-image: url("../../assets/icon/coupang_menu_product.png");
}
.coupang-group-li.group-inbound .coupang-group-header:before {
    background-image: url("../../assets/icon/coupang_menu_inbound.png");
}
.coupang-group-li.group-outbound .coupang-group-header:before {
    background-image: url("../../assets/icon/coupang_menu_outbound.png");
}
.coupang-group-header .arrow-icon {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    color: var(--main-color);
}
.coupang-group-header:hover {
    background: rgba(255, 87, 0, 0.05);
    color: #ff5700;
}
.coupang-sub-menu {
    list-style: none;
    padding: 5px 15px 10px 15px;
    margin: 0;
    border-top: 1px dashed #ddd;
}
.coupang-sub-menu li {
    margin-bottom: 4px;
    background: transparent;
    border: none;
    position: relative;
}
.coupang-sub-menu a {
    display: block;
    padding: 8px 15px;
    color: #555;
    font-size: 14px;
    border-radius: 8px;
    transition: all 0.2s;
    cursor: pointer;
}
.coupang-sub-menu a:hover {
    background: rgba(255, 87, 0, 0.05);
    color: #ff5700;
    padding-left: 20px;
}
.active-coupang-item > a {
    background: rgba(255, 87, 0, 0.08) !important;
    color: #ff5700 !important;
    font-weight: bold;
}
.active-coupang-item.coupang-group-li {
    border-color: var(--main-color);
    background: #fff6f0;
}
.embed-component-wrapper {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.03);
    padding: 20px;
    min-height: 500px;
}
.embed-component-wrapper ::v-deep .content-zsy {
	width: 100% !important;
	max-width: 100% !important;
	margin: 0 !important;
	padding: 0 !important;
}
.embed-component-wrapper ::v-deep .banner-container,
.embed-component-wrapper ::v-deep .inventory-navi {
	display: none !important;
}

/* Fix squished search filters inside all embedded coupang components */
@media (min-width: 769px) {
	.embed-component-wrapper ::v-deep .condition-wrap > .el-row {
		display: flex !important;
		flex-wrap: wrap !important;
		align-items: center !important;
		gap: 15px !important;
	}
	.embed-component-wrapper ::v-deep .condition-wrap > .el-row > .el-col {
		width: auto !important;
		flex: none !important;
		padding: 0 !important;
	}
	.embed-component-wrapper ::v-deep .condition-wrap > .el-row > .el-col .el-row {
		display: flex !important;
		align-items: center !important;
		gap: 8px !important;
	}
	.embed-component-wrapper ::v-deep .condition-wrap > .el-row > .el-col .el-row > .el-col {
		width: auto !important;
		flex: none !important;
		padding: 0 !important;
	}
	.embed-component-wrapper ::v-deep .condition-wrap .unit {
		width: auto !important;
		padding: 0 5px 0 0 !important;
		white-space: nowrap !important;
	}
	.embed-component-wrapper ::v-deep .condition-wrap .el-select {
		width: 130px !important;
	}
	.embed-component-wrapper ::v-deep .condition-wrap .unit-input {
		width: 140px !important;
	}
	.embed-component-wrapper ::v-deep .condition-wrap .el-date-editor.el-input {
		width: 130px !important;
	}
}

</style>